import React from 'react';
import numbro from 'numbro';
import IssuedInvoicesList from './IssuedInvoicesList';
import { getLanguagesInArray } from '@data/translations';
import { setModalContent, closeModal, showConfirmationModal } from '@components/modal';
import LoadingButton from '@components/buttons/loadingButton';
import ConfirmButtons from '@components/buttons/confirmButtons';
import CurrentOffer from './CurrentOffer';
import GroupReservationActions from './GroupReservationActions';
import { condoStatusCheck } from '@pages/newReservations/utils';
import { ConsumptionInvoiceList } from './IssuedInvoicesList';
import { searchInvoice, getPosItems } from './api';
import translate from '@data/translations';
import { ReactComponent as Cash } from '../../../assets/custom/icons/cash.svg';
import { ReactComponent as Card } from '../../../assets/custom/icons/card.svg';
import { ReactComponent as Bill } from '../../../assets/custom/icons/bill.svg';
import chevronDown from '../../../assets/custom/icons/chevron_down.svg';
import { ReactComponent as Trash } from '../../../assets/custom/icons/trash.svg';
//@ts-ignore
import { Link } from 'react-router-dom';
import {
    stornoInvoice,
    stayOverActions,
    setInvoiceType,
    issueInvoice,
    applyCurrentCheckoutDate,
    // openInNewTab,
    ignoreCheckoutDateMismatch,
    setInvoiceProperties,
    setInvoiceStornoPreview,
    setReclamationReason,
    setAccommodationInvoice,
    loadCheckoutInvoice,
    addOrRemoveInvoice,
    splitInvoice,
    restorePreviousCheckoutDate,
    undoLastOffer,
    setLoyaltyProgram,
    recalculateReservationInvoice,
} from './controler';
import { getGeneralSettingsByPrefix } from './api';
import { CheckoutOptionsProps, ConfirmationModalProps, InvoiceTypeEnum, PaymentType } from './interfaces';
import {
    InvoiceModelWithInvoiceItems,
    PosTerminalModel,
    ReservationEditModel,
    GeneralSettingModel,
    InvoiceItemsModel,
    PosItemModel,
    PosTerminalConsumption,
    PriceOffer,
    ReservationStatus,
} from '@common/modelDefinition';
import dayjs from 'dayjs';
import { ReactComponent as CompanyAndCustomerIcon } from '../../../assets/custom/icons/users.svg';
import useStore from '@data/state/zustand';
import { stopGlobalLoading } from '@components/loaders/globalLoading';
import PermissionCheck from '@components/PermissionCheck';

var searchDebouncer: NodeJS.Timeout = setTimeout(() => {}, 0);

const CheckoutOptions = (props: CheckoutOptionsProps) => {
    return (
        <div>
            <div className="display-flex justify-content-between mobile-column">
                <div>
                    <div className="mb-4p">
                        <b>{translate('Type of invoice')}</b>
                    </div>
                    <SelectInvoiceType {...props} />
                </div>
                <div>
                    <div className="mb-4p">
                        <b>{translate('Currency')}</b>
                    </div>

                    <CurrencySelection
                        setCurrencyViaPropsAction={setInvoiceProperties}
                        invoice={props.invoice}
                        location={props.location}
                    />
                </div>
            </div>
            <div className="display-flex justify-content-between mt-16p flex-wrap mobile-column">
                <TypeOfPayment {...props} />
            </div>

            <div className="page-title-button display-flex-mobile mobile-column">
                <div className="flex-center mobile-mt-12p">
                    <SelectLocale
                        setLocaleViaPropsAction={setInvoiceProperties}
                        invoice={props?.invoice}
                        systemLocale={props?.systemLocale}
                        location={props.location}
                    />

                    <button
                        disabled={!props?.pendingInvoice || !props?.id}
                        onClick={() => {
                            if (props?.setShowCustomerAndCompanies) {
                                props?.setShowCustomerAndCompanies(
                                    props?.showCustomerAndCompanies !== undefined
                                        ? !props?.showCustomerAndCompanies
                                        : false
                                );
                            }
                        }}
                        className={'button-white-w-icon-only'}
                    >
                        <CompanyAndCustomerIcon width={28} height={28} />
                    </button>
                </div>
            </div>

            <div className="mt-16p">
                <InvoiceNote {...props} />
            </div>
            <div className="mt-16p">
                <CreateOrFindInvoice {...props} />
            </div>

            <div className="flex-center mt-16p flex-wrap">
                <LoyaltyDiscount {...props} />
                <GeneralDiscount {...props} />
            </div>

            <div className="mt-16p">
                <AccommodationInvoice {...props} />
            </div>
            <div className="">
                <CurrentOffer {...props} />
            </div>
            <div className="mt-16p">{props?.groupUuid ? <GroupReservationActions {...props} /> : null}</div>

            <div className="mt-16p ">
                <IssuedInvoicesList {...props} />
            </div>
        </div>
    );
};

const StornoInvoice = (props: CheckoutOptionsProps) => {
    const { invoiceStornoPreview, reservationId, groupUuid } = props; //stornoInvoice - jer pozivam drugačiju akciju na PrintView-u

    if (!invoiceStornoPreview) {
        return null;
    }
    const { reclamationReason, id } = invoiceStornoPreview; //defaultCurrency u invojsu je valuta u trenutku izdavanja računa, dakle nije jednaka onom iz frontedna i baobaba

    return (
        <div className="mr-8p ml-8p mb-12p mt-12p">
            <ReclamationReason {...props} />
            <div className="d-flex justify-content-end mt-2">
                <LoadingButton
                    disabled={false}
                    onClick={async () => {
                        try {
                            if (id) {
                                try {
                                    await stornoInvoice(reclamationReason, reservationId, groupUuid);
                                    // const issuedStornoInvoice = getIssuedStornoInvoice(id);
                                    // if (process.env.NODE_ENV === 'development') {
                                    //     openInNewTab(
                                    //         `http://localhost:5555/#/invoiceView/${issuedStornoInvoice.id}?noActions`
                                    //     );
                                    // } else {
                                    //     openInNewTab(
                                    //         window.location.origin +
                                    //             `/#/invoiceView/${issuedStornoInvoice.id}?noActions`
                                    //     );
                                    // }
                                    setInvoiceStornoPreview(null);
                                } catch (error) {
                                    stopGlobalLoading();
                                    setInvoiceStornoPreview(null);
                                    console.log('error:', error);
                                }
                            }
                        } catch (err: any) {
                            stopGlobalLoading();

                            console.log(err.message);
                        }
                    }}
                    className={'button-primary mr-8p'}
                >
                    {translate('Storno invoice')}
                </LoadingButton>

                <button
                    onClick={async () => {
                        setReclamationReason(null);
                        setInvoiceStornoPreview(null);
                    }}
                    className="button-light"
                >
                    {translate('Cancel')}
                </button>
            </div>
        </div>
    );
};

const ReclamationReason = (props: CheckoutOptionsProps) => {
    const { invoiceStornoPreview } = props;
    if (!invoiceStornoPreview) {
        return null;
    }

    const { reclamationReason = '', pendingInvoice } = invoiceStornoPreview;
    const disabled: boolean = pendingInvoice ? true : false;

    return (
        <div className="d-flex justify-content-center mb-2 ">
            <textarea
                autoFocus
                disabled={disabled}
                onChange={(e) => {
                    if (setReclamationReason) {
                        setReclamationReason(e.target.value);
                    }
                }}
                // onBlur={() => setReclamationReason(localReclamationReason)}
                value={reclamationReason ? reclamationReason : ''}
                className="form-control"
                placeholder={translate('Reclamation reason')}
            ></textarea>
        </div>
    );
};

interface SelectLocaleProps {
    invoice: InvoiceModelWithInvoiceItems;
    setLocaleViaPropsAction: Function;
    systemLocale: string;
    location: any;
}

const SelectLocale = (props: SelectLocaleProps) => {
    const { invoice, setLocaleViaPropsAction, systemLocale, location } = props;
    const { locale = 'eng', pendingInvoice } = invoice;
    const languages: string[] = getLanguagesInArray();

    const isPrintView: boolean = location && location.pathname.lastIndexOf('invoiceView') !== -1 ? true : false;
    return (
        <div>
            <div className="btn-group mb-md-0" role="group" aria-label="Select locale">
                {languages.map((l: string, index) => {
                    let className = '';
                    if (l === systemLocale) {
                        if (l === locale) {
                            //odabrana je primarna valuta
                            className = 'button-light-selected mr-4p';
                        } else {
                            className = 'button-light-not-selected mr-4p';
                        }
                    } else {
                        if (l === locale) {
                            className = 'button-light-selected mr-4p';
                        } else {
                            className = 'button-light-not-selected mr-4p';
                        }
                    }
                    return (
                        <button
                            disabled={(!invoice.id || !pendingInvoice) && !isPrintView ? true : false}
                            onClick={() => {
                                setLocaleViaPropsAction('locale', l);
                            }}
                            className={className}
                            key={index}
                        >
                            {l}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

interface CurrencySelectionProps {
    invoice: InvoiceModelWithInvoiceItems;
    setCurrencyViaPropsAction: Function;
    location: any;
}

const CurrencySelection = (props: CurrencySelectionProps) => {
    const { invoice, setCurrencyViaPropsAction, location } = props;

    const { exchangeRates = null, defaultCurrency, currency, invoiceType, pendingInvoice } = invoice;
    if (exchangeRates === null) {
        return null;
    }

    const invoiceCurrencies: any = JSON.parse(exchangeRates);
    const currencies: string[] = [];

    Object.keys(invoiceCurrencies).forEach((currShortName: string) => {
        currencies.push(currShortName);
    });

    const isPrintView: boolean = location && location.pathname.lastIndexOf('invoiceView') !== -1 ? true : false;

    return (
        <div className="display-flex flex-wrap">
            {currencies.map((c: string, index: number) => {
                let className = '';
                if (c === defaultCurrency) {
                    if (c === currency) {
                        //odabrana je primarna valuta
                        className = 'button-light-selected mr-4p mb-4p';
                    } else {
                        className = 'button-light-not-selected mr-4p mb-4p';
                    }
                } else {
                    if (c === currency) {
                        className = 'button-light-selected mr-4p mb-4p';
                    } else {
                        className = 'button-light-not-selected mr-4p mb-4p';
                    }
                }
                return (
                    <button
                        disabled={
                            (invoiceType === InvoiceTypeEnum.advance || !invoice.id || !pendingInvoice) && !isPrintView
                        }
                        onClick={() => {
                            setCurrencyViaPropsAction('currency', c);
                        }}
                        className={className}
                        key={index}
                    >
                        {c}
                    </button>
                );
            })}
        </div>
    );
};

//ovo je primjer kada ne želim odmah upucati akciju i slati sve na backend da se prekalkulira čitav račun
//umjesto toga, keširam note u stanje komponente i pucam akciju tek kada skinem fokus sa inpute
const InvoiceNote = (props: CheckoutOptionsProps) => {
    const { invoice, translate } = props;
    const { note = '', pendingInvoice } = invoice;
    const disabled: boolean = !pendingInvoice;
    const [localNote, setLocalNote] = React.useState<string>(note ? note : '');
    const [genericNotes, setGenericNotes] = React.useState([]);
    const [selectedNote, setSelectedNote] = React.useState<string | null>(null);
    React.useEffect(() => {
        if (note) {
            setLocalNote(note); //kada dobijem osvježenu porku iz propsa, ažuriram i lokalno stanje
        } else {
            setLocalNote('');
        }
    }, [note]);

    React.useEffect(() => {
        const loadData = async () => {
            const _genericNotes = await getGeneralSettingsByPrefix();
            setGenericNotes(_genericNotes);
        };
        loadData().catch((err) => {
            console.log(err);
        });
        // eslint-disable-next-line
    }, []);

    if (disabled) {
        return null;
    }

    return (
        <div className="">
            <div className="mb-4p">
                <b>{translate('Invoice note')}</b>
            </div>
            <div className="">
                <select
                    disabled={disabled || !invoice.id ? true : false}
                    name="taxFreeReason"
                    className="form-control form-control-sm"
                    value={selectedNote ? selectedNote : ''}
                    onChange={async (e) => {
                        if (e.target.value) {
                            setSelectedNote(e.target.value);
                            const targetNote: GeneralSettingModel | undefined = genericNotes.find(
                                (g: GeneralSettingModel) => g.key === e.target.value
                            );
                            if (targetNote) {
                                const { params } = targetNote;
                                if (params) {
                                    const note = localNote.length > 0 ? `${localNote}\n${params}` : params;
                                    setInvoiceProperties('note', note);
                                }
                            }
                        }
                    }}
                >
                    <React.Fragment>
                        <option value={''} disabled defaultValue={''} key={'noReason'}>
                            {translate('Select a predefined invoice note')}
                        </option>
                        {genericNotes.map((g: any) => {
                            return (
                                <option value={g.key} key={g.uuid}>
                                    {g.key.split('_').map((text: string, index: number) => {
                                        if (index === 1) {
                                            return text;
                                        } else {
                                            return null;
                                        }
                                    })}
                                </option>
                            );
                        })}
                    </React.Fragment>
                </select>
            </div>
            <div className="mt-4p">
                <textarea
                    disabled={disabled || !invoice.id ? true : false}
                    onChange={(e) => {
                        setLocalNote(e.target.value);
                    }}
                    onBlur={() => setInvoiceProperties('note', localNote)}
                    value={localNote ? localNote : ''}
                    className="form-control form-control-sm"
                    placeholder={translate('Or write a custom invoice note...')}
                ></textarea>
            </div>
        </div>
    );
};

export const InvoiceActions = (props: CheckoutOptionsProps) => {
    const {
        invoice,
        advanceInvoices,
        // checkoutDateMismatchs,
        reservation,
        availableForAdvancePayment,
        reservationId,
        groupUuid,
        invoiceStornoPreview,
        invoicePreview,
    } = props;
    const {
        invoiceType = InvoiceTypeEnum.geniue,
        pendingInvoice,
        totalValue,
        partialPayment /*, terminalType*/,
    } = invoice;

    const disableWhenAdvance: boolean = // Izdajemo avans a vrijednost je 0
        invoiceType === InvoiceTypeEnum.advance &&
        (totalValue === 0 || (advanceInvoices.length > 0 && !partialPayment) || availableForAdvancePayment === 0);
    const disableWhenGenuine: boolean = // Izdajemo genuine a rezervacija je blokirana ili cancelirana
        invoiceType === InvoiceTypeEnum.geniue && reservation && reservation.statusEnum === 5 ? true : false; // šta ako storniramo račun nakon checkouta

    const disableWhenTotal: boolean = advanceInvoices.length === 0 && (totalValue === 0 || totalValue === null); // Nije bilo avansnih uplata a rijednost računa je 0

    // const isCondoReservation: boolean = reservation && condoStatusCheck(reservation).isCondoReservation ? true : false;

    const disableIfCheckoutDateMismatch: boolean = false;
    //   checkoutDateMismatchs.length > 0 && !isCondoReservation && terminalType === 'reservation';

    const disableOnInvoicePreview: boolean =
        invoicePreview && Object.keys(invoicePreview.invoice).length > 0 ? true : false;

    const disableAlways = !pendingInvoice || invoiceStornoPreview ? true : false;

    const disabled: boolean =
        disableWhenAdvance ||
        disableWhenGenuine ||
        disableWhenTotal ||
        disableIfCheckoutDateMismatch ||
        !invoice.id ||
        disableOnInvoicePreview ||
        disableAlways;
    let issueInvoiceActionText: string | null = null;
    switch (invoiceType) {
        case InvoiceTypeEnum.geniue:
            issueInvoiceActionText = translate('Issue invoice');
            break;
        case InvoiceTypeEnum.advance:
            issueInvoiceActionText = translate('Issue advance invoice');
            break;
        default:
            issueInvoiceActionText = translate('Issue proforma');
            break;
    }

    return (
        <div className="text-center">
            <button
                disabled={disabled}
                onClick={() =>
                    setModalContent(
                        <div className="container-fluid">
                            <div className="text-center">
                                {translate('Please confirm.')}
                                <hr />
                            </div>

                            <div className="text-center">
                                <ConfirmButtons
                                    onConfirm={async () => {
                                        try {
                                            await issueInvoice(reservationId, groupUuid);
                                            // if (process.env.NODE_ENV === 'development') {
                                            //     openInNewTab(
                                            //         `http://localhost:5555/#/invoiceView/${invoice.id}?noActions`
                                            //     );
                                            // } else {
                                            //     openInNewTab(
                                            //         window.location.origin + `/#/invoiceView/${invoice.id}?noActions`
                                            //     );
                                            // }
                                            closeModal();
                                        } catch (error) {
                                            stopGlobalLoading();
                                            closeModal();
                                            console.log('error:', error);
                                        }
                                    }}
                                    onCancel={() => {
                                        closeModal();
                                    }}
                                />
                            </div>
                        </div>,
                        translate('Issue invoice'), // header
                        false, // showCloseButton
                        'modal-md'
                    )
                }
                className="button-primary mr-16p no-print"
            >
                {issueInvoiceActionText}
            </button>
        </div>
    );
};

const SelectInvoiceType = (props: CheckoutOptionsProps) => {
    const { invoice /*invoiceItems, advanceInvoices*/, translate, advanceInvoices } = props;
    const {
        invoiceType = InvoiceTypeEnum.geniue,
        pendingInvoice /*reclamation*/,
        terminalType,
        connectedInvoices,
    } = invoice;

    const regularSelection: string =
        invoiceType === InvoiceTypeEnum.geniue ? 'button-light-selected mr-4p' : 'button-light-not-selected mr-4p';
    const avansSelection: string =
        invoiceType === InvoiceTypeEnum.advance ? 'button-light-selected mr-4p' : 'button-light-not-selected mr-4p';
    const proformaSelection: string =
        invoiceType === InvoiceTypeEnum.proforma ? 'button-light-selected mr-4p' : 'button-light-not-selected mr-4p';

    const disableIfConnected: boolean =
        terminalType === 'reservation' && connectedInvoices.length > 0
            ? true
            : terminalType === 'reservationConsumption' && connectedInvoices.length > 1
            ? true
            : false;

    const disableAdvanceInvoice: boolean = disableIfConnected || !invoice.id;

    const disableProformaSelectWhenAdvancereference = advanceInvoices.filter((a) => {
        if (
            a.connectedInvoices &&
            a.connectedInvoices.length > 0 &&
            connectedInvoices &&
            connectedInvoices.length > 0 &&
            connectedInvoices.includes(a.connectedInvoices[0])
        ) {
            return a;
        } else {
            return null;
        }
    });
    const disabledProformaInvoice: boolean =
        !invoice.id || disableProformaSelectWhenAdvancereference.length > 0 || invoice.advancePayments?.length > 0;
    if (!pendingInvoice) {
        return null;
    }
    return (
        <div className="button-group truncated mb-8p">
            <button
                disabled={!invoice.id ? true : false}
                onClick={() => setInvoiceType(InvoiceTypeEnum.geniue)}
                className={`${regularSelection} `}
            >
                {translate('Regular invoice')}
            </button>

            <button
                disabled={disableAdvanceInvoice}
                onClick={() => setInvoiceType(InvoiceTypeEnum.advance)}
                className={`${avansSelection} `}
            >
                {translate('Advance')}
            </button>

            <button
                disabled={disabledProformaInvoice}
                onClick={() => setInvoiceType(InvoiceTypeEnum.proforma)}
                className={`${proformaSelection} `}
            >
                {translate('Proforma')}
            </button>
        </div>
    );
};

const GeneralDiscount = (props: CheckoutOptionsProps) => {
    const { invoice, translate, proformaInvoices } = props;
    const { pendingInvoice, invoiceType, id } = invoice;

    const generalDiscountPercentage = invoice.generalDiscountPercentage ? invoice.generalDiscountPercentage : 0;
    const [localDiscountPercentage, setLocalDiscountPercentage] = React.useState<number>(0);

    const latestGivenGeneralDiscountProforma: number =
        proformaInvoices.length > 0 ? proformaInvoices[proformaInvoices.length - 1].generalDiscountPercentage : 0;

    React.useEffect(() => {
        if (id && generalDiscountPercentage !== null) {
            setLocalDiscountPercentage(generalDiscountPercentage);
        }
    }, [id, generalDiscountPercentage]);

    const handleDiscount = (e: any) => {
        let percentage = e.target.value ? Number(e.target.value) : 0; // ne radi ovaj max, vjerovatno ima veze sa gazenjem sa backenda
        if (Number(e.target.value) >= 100) {
            percentage = 100;
        }
        setLocalDiscountPercentage(percentage);
    };

    if (!pendingInvoice || invoiceType === InvoiceTypeEnum.advance || !invoice.id) {
        return null;
    }

    return (
        <div className="truncated truncated-align-start">
            <div className="mb-4p">
                <b>{translate('Invoice discount')}</b>
            </div>

            <div className="button-group">
                <input
                    style={{ width: '80px' }}
                    className={
                        latestGivenGeneralDiscountProforma &&
                        latestGivenGeneralDiscountProforma > localDiscountPercentage
                            ? 'input input-field-invalid'
                            : 'input input-field'
                    }
                    id={'pl-discount'}
                    name="discount"
                    placeholder={translate('0%')}
                    autoComplete="off"
                    type="number"
                    min={0}
                    max={100}
                    value={localDiscountPercentage ? localDiscountPercentage : ''}
                    onChange={handleDiscount}
                />

                {generalDiscountPercentage !== localDiscountPercentage ? (
                    <button
                        disabled={latestGivenGeneralDiscountProforma > localDiscountPercentage ? true : false}
                        onClick={() => {
                            setInvoiceProperties('generalDiscountPercentage', localDiscountPercentage);
                            if (localDiscountPercentage < latestGivenGeneralDiscountProforma) {
                                setLocalDiscountPercentage(latestGivenGeneralDiscountProforma);
                                setInvoiceProperties('generalDiscountPercentage', latestGivenGeneralDiscountProforma); // Inače bi u slučaju storna predračuna primjenuo zadnji unesen manji iznos
                            }
                        }}
                        className="button-white-only ml-4p"
                    >
                        {translate('Apply')}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

/*
avansna uplata, tj. paymentAmount mora biti spremljena u bazu u lokalnoj valuti! To je mandatorno od backenda!
Sve vezane transformacije za valutne konverzije moraju biti na jendom mjestu, u ovom slučaju to je ova frontend komponente.
u najgorem slučaju, avans se treba omogućiti samo u domaćoj valuti da ne bude problema sa zaokruživanjem - ili napraviti neku konzolu za konverziju!
*/
export const PaymentAmount = (props: CheckoutOptionsProps) => {
    const { invoice, translate, availableForAdvancePayment = 0 } = props;
    const {
        currency,
        pendingInvoice,
        invoiceType,
        partialPayment = false,
        paymentAmount = 0,
        currencyExchangeRate,
    } = invoice;

    const availablePaymentAmount: number = availableForAdvancePayment * currencyExchangeRate; //exchange rateo dabrane valute
    const [localPaymentAmount, setLocalPaymentAmount] = React.useState<number | null>(paymentAmount);

    React.useEffect(() => {
        if (paymentAmount) {
            setLocalPaymentAmount(paymentAmount);
        }
    }, [paymentAmount]);

    const convertPaymentAmountToDefaultCurrency = () => {
        if (localPaymentAmount) {
            setInvoiceProperties('paymentAmount', localPaymentAmount); //
        }
    };

    const setComponentPaymentAmount = (e: any) => {
        const val = Number(e.target.value);
        if (!isNaN(val) && val >= e.target.min) {
            if (val <= e.target.max) {
                setLocalPaymentAmount(val);
            } else if (val > e.target.max) {
                setLocalPaymentAmount(val); //Number(e.target.max)
            }
        }
    };

    if (invoiceType !== InvoiceTypeEnum.advance) {
        return null;
    }
    return (
        <div className="mr-16p">
            <div className="display-flex align-items-center">
                <div
                    className={'button-link'}
                    style={{ paddingTop: '0px' }}
                    onClick={async () => {
                        await setInvoiceProperties('partialPayment', !partialPayment);
                        if (partialPayment) {
                            await setInvoiceProperties('paymentAmount', null); //
                        }
                    }}
                >
                    {translate(partialPayment ? 'Full amount' : 'Partial payment')}
                </div>

                {partialPayment ? (
                    <div className="display-flex align-items-end">
                        <div className="text-left">
                            <div style={{ width: '200px' }} className="input-group input-group-sm">
                                <input
                                    disabled={!pendingInvoice}
                                    name="paymentAmount"
                                    autoComplete="off"
                                    value={localPaymentAmount ? localPaymentAmount : ''}
                                    onChange={setComponentPaymentAmount}
                                    type="number"
                                    className="form-control"
                                    max={availablePaymentAmount ? availablePaymentAmount : ''}
                                    min={0}
                                />
                                <div className="input-group-append d-block">
                                    <span className="input-group-text" id="currency">
                                        {translate('of')}{' '}
                                        {availablePaymentAmount
                                            ? numbro(availablePaymentAmount).format({
                                                  mantissa: 2,
                                                  trimMantissa: true,
                                              })
                                            : ''}{' '}
                                        {currency}
                                    </span>
                                </div>
                            </div>
                        </div>
                        {paymentAmount !== localPaymentAmount && localPaymentAmount !== 0 ? (
                            <button onClick={convertPaymentAmountToDefaultCurrency} className="button-primary ml-8p">
                                {translate('Update')}
                            </button>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export const CheckoutGroupOptions = (props: CheckoutOptionsProps) => {
    const {
        invoice = null,
        checkoutDateMismatchs,
        reservation,
        // stayoverOverlap,
        translate,
        location,
        reservationId,
        groupUuid,
        index,
    } = props;
    const [showMoreOptions, setShowMoreOptions] = React.useState<number | null>(null);
    const wrapperRef = React.useRef(null);

    useOutsideAlerter(wrapperRef, showMoreOptions);

    function useOutsideAlerter(ref: any, showMoreOptions: number | null) {
        React.useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target) && event.target.id !== 'groupOptions' + index) {
                    if (showMoreOptions !== null) {
                        setShowMoreOptions(null);
                    }
                }
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref, showMoreOptions]);
    }

    if (!reservation || !invoice) {
        return <div className="pl-16p pr-16p pt-16p pb-16p"></div>;
    }
    const { id } = reservation;

    const reservationCheckoutDateMismatch: boolean =
        checkoutDateMismatchs?.length > 0
            ? checkoutDateMismatchs.filter((r) => r === id).length > 0
                ? true
                : false
            : false;

    const { isCondoReservation } = condoStatusCheck(reservation);

    const { pendingInvoice, terminalType } = invoice;
    const showMissmatchDate: boolean =
        reservationCheckoutDateMismatch &&
        pendingInvoice &&
        !isCondoReservation &&
        terminalType === 'reservation' &&
        invoice.id
            ? true
            : false;

    const { rememberedAccommodationPriceInfo } = reservation;

    const lastOffer: PriceOffer | null =
        rememberedAccommodationPriceInfo && rememberedAccommodationPriceInfo.length > 0
            ? rememberedAccommodationPriceInfo[rememberedAccommodationPriceInfo.length - 1]
            : null;

    const mismatchDateApplied: boolean =
        reservation && lastOffer && !dayjs(reservation.checkOutTimestamp).isSame(lastOffer.checkOutTimestamp, 'day')
            ? true
            : false;

    let showPreviousOffer: boolean = false;
    if (rememberedAccommodationPriceInfo && rememberedAccommodationPriceInfo.length > 1) {
        showPreviousOffer = true;
    }

    const showMissmatch =
        reservation.statusEnum === ReservationStatus.checkedIn && mismatchDateApplied && pendingInvoice && invoice.id
            ? true
            : false;

    const showPrevious = showPreviousOffer && pendingInvoice && invoice.id ? true : false;

    if (!showPrevious && !showMissmatch && !showMissmatchDate) {
        return <div className="pl-16p pr-16p pt-16p pb-16p"></div>;
    }

    return (
        <React.Fragment>
            {showMissmatchDate || showMissmatch || showPrevious ? (
                <div className="" style={{ position: 'relative' }}>
                    <div
                        className="display-flex justify-content-end align-items-center"
                        title={translate('checkoutDateMissmatchNote')
                            .replace('{X}', dayjs(reservation.checkOutTimestamp).format('ll'))
                            .replace('{Y}', reservation.id)
                            .replace('{Z}', dayjs().format('ll'))}
                    >
                        <div
                            className="pointer text-primary"
                            onClick={(e) => {
                                e.stopPropagation();

                                if (index !== undefined) {
                                    if (showMoreOptions !== null) {
                                        if (showMoreOptions === index) {
                                            setShowMoreOptions(null);
                                        } else {
                                            setShowMoreOptions(index);
                                        }
                                    } else {
                                        setShowMoreOptions(index);
                                    }
                                }
                            }}
                        >
                            <img id={'groupOptions' + index} src={chevronDown} alt="" />
                        </div>
                    </div>

                    {showMoreOptions === index && (showMissmatchDate || showMissmatch || showPrevious) ? (
                        <div ref={wrapperRef} className="more-options-checkout-wrapper shadow-sm">
                            {showMissmatchDate ? (
                                <div
                                    className="more-options-checkout pl-8p pr-8p pt-8p pb-8p"
                                    onClick={() => {
                                        setModalContent(
                                            <div className="container-fluid">
                                                <div className="text-center">
                                                    {translate('Please confirm.')}
                                                    <hr />
                                                </div>

                                                <div className="text-center">
                                                    <ConfirmButtons
                                                        onConfirm={async () => {
                                                            await applyCurrentCheckoutDate(
                                                                reservation,
                                                                location,
                                                                reservationId,
                                                                groupUuid
                                                            );
                                                            closeModal();
                                                        }}
                                                        onCancel={() => {
                                                            closeModal();
                                                        }}
                                                    />
                                                </div>
                                            </div>,

                                            translate('Apply new check out date'), // header
                                            false, // showCloseButton
                                            'modal-md'
                                        );
                                    }}
                                >
                                    <div className="ml-8p pointer">{translate('Apply current date')}</div>
                                </div>
                            ) : null}
                            {showMissmatchDate ? (
                                <div
                                    className="more-options-checkout pl-8p pr-8p pt-8p pb-8p"
                                    onClick={() => {
                                        ignoreCheckoutDateMismatch(reservation);
                                    }}
                                >
                                    <div className="ml-8p pointer">{translate('Ignore warning')}</div>
                                </div>
                            ) : null}
                            {showMissmatch ? (
                                <div
                                    className="more-options-checkout pl-8p pr-8p pt-8p pb-8p"
                                    onClick={() => {
                                        const confirmationModalProps: ConfirmationModalProps = {
                                            title: translate('Previous checkout date'),
                                            callback: () => {
                                                restorePreviousCheckoutDate(
                                                    reservation,
                                                    location,
                                                    reservationId,
                                                    groupUuid
                                                );
                                            },
                                        };
                                        showConfirmationModal(confirmationModalProps);
                                    }}
                                >
                                    <div className="ml-8p pointer">{translate('Previous checkout date')}</div>
                                </div>
                            ) : null}
                            {showPrevious ? (
                                <div
                                    className="more-options-checkout pl-8p pr-8p pt-8p pb-8p"
                                    onClick={() => {
                                        setModalContent(
                                            <div className="container-fluid">
                                                <div className="text-center">
                                                    {translate('Please confirm.')}
                                                    <hr />
                                                </div>

                                                <div className="text-center">
                                                    <ConfirmButtons
                                                        onConfirm={async () => {
                                                            await undoLastOffer({
                                                                reservationId,
                                                                groupUuid,
                                                            });

                                                            await loadCheckoutInvoice({ reservationId, groupUuid });
                                                            closeModal();
                                                        }}
                                                        onCancel={() => {
                                                            closeModal();
                                                        }}
                                                    />
                                                </div>
                                            </div>,

                                            translate('Undo last offer'), //  header
                                            false, // showCloseButton
                                            'modal-md'
                                        );
                                    }}
                                >
                                    <div className="ml-8p pointer">{translate('Undo last offer')}</div>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            ) : null}
        </React.Fragment>
    );
};

const CheckoutDateMissmatch = (props: CheckoutOptionsProps) => {
    const {
        invoice = null,
        checkoutDateMismatchs,
        reservation,
        // stayoverOverlap,
        translate,
        location,
        reservationId,
        groupUuid,
        // key,
    } = props;
    const [showMoreOptions, setShowMoreOptions] = React.useState<boolean>(false);
    const wrapperRef = React.useRef(null);

    useOutsideAlerter(wrapperRef, showMoreOptions);

    function useOutsideAlerter(ref: any, showMoreOptions: boolean) {
        React.useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target) && event.target.id !== 'options') {
                    if (showMoreOptions !== false) {
                        setShowMoreOptions(false);
                    }
                }
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref, showMoreOptions]);
    }

    if (!reservation || !invoice) {
        return null;
    }
    const { id } = reservation;

    const reservationCheckoutDateMismatch: boolean =
        checkoutDateMismatchs?.length > 0
            ? checkoutDateMismatchs.filter((r) => r === id).length > 0
                ? true
                : false
            : false;

    const { isCondoReservation } = condoStatusCheck(reservation);

    const { pendingInvoice, terminalType } = invoice;
    const showMissmatch: boolean =
        reservationCheckoutDateMismatch &&
        pendingInvoice &&
        !isCondoReservation &&
        terminalType === 'reservation' &&
        invoice.id
            ? true
            : false;
    return (
        <React.Fragment>
            {showMissmatch ? (
                <div className="" style={{ position: 'relative' }}>
                    <div
                        className="display-flex justify-content-end align-items-center"
                        title={translate('checkoutDateMissmatchNote')
                            .replace('{X}', dayjs(reservation.checkOutTimestamp).format('ll'))
                            .replace('{Y}', reservation.id)
                            .replace('{Z}', dayjs().format('ll'))}
                    >
                        <React.Fragment>
                            <div className="mr-8p">{translate('Check out dates are different.')}</div>
                            <div
                                className="pointer text-primary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowMoreOptions(!showMoreOptions);
                                }}
                            >
                                <b id="options">{translate('Options...')}</b>
                            </div>
                        </React.Fragment>
                    </div>

                    {showMoreOptions && showMissmatch ? (
                        <div ref={wrapperRef} className="more-options-checkout-wrapper shadow-sm">
                            <div
                                className="more-options-checkout pl-8p pr-8p pt-8p pb-8p"
                                onClick={() => {
                                    setModalContent(
                                        <div className="container-fluid">
                                            <div className="text-center">
                                                {translate('Please confirm.')}
                                                <hr />
                                            </div>

                                            <div className="text-center">
                                                <ConfirmButtons
                                                    onConfirm={async () => {
                                                        await applyCurrentCheckoutDate(
                                                            reservation,
                                                            location,
                                                            reservationId,
                                                            groupUuid
                                                        );
                                                        closeModal();
                                                    }}
                                                    onCancel={() => {
                                                        closeModal();
                                                    }}
                                                />
                                            </div>
                                        </div>,

                                        translate('Apply new check out date'), // header
                                        false, // showCloseButton
                                        'modal-md'
                                    );
                                }}
                            >
                                {/* <div className=" mr-8p">
                                                                  <Edit />
                                                              </div> */}
                                <div className="ml-8p pointer">{translate('Apply current date')}</div>
                            </div>
                            <div
                                className="more-options-checkout pl-8p pr-8p pt-8p pb-8p"
                                onClick={() => {
                                    ignoreCheckoutDateMismatch(reservation);
                                }}
                            >
                                <div className="ml-8p pointer">{translate('Ignore warning')}</div>
                            </div>
                        </div>
                    ) : null}
                </div>
            ) : null}
        </React.Fragment>
    );
};

export const OverlapOptions = (props: CheckoutOptionsProps) => {
    const { invoice = null, reservation, stayoverOverlap, translate, location, reservationId, groupUuid } = props;

    if (!reservation || !invoice) {
        return null;
    }

    const { roomInfoId } = reservation;

    const overlapReservations: ReservationEditModel[] = stayoverOverlap.overlapReservations;

    const optionCheck: number | null =
        overlapReservations.length > 0 && stayoverOverlap.type === 'applyCurrentDate' ? stayoverOverlap.option : null;
    const type: string | null = stayoverOverlap ? stayoverOverlap.type : null;

    const targetOverlapSelection: ReservationEditModel | undefined = overlapReservations?.find(
        (r: ReservationEditModel) => Number(r.roomInfoId) === Number(roomInfoId)
    );
    if (targetOverlapSelection && type === 'applyCurrentDate') {
        return (
            <div className="mb-4p">
                {overlapReservations.length > 1 ? (
                    <div id="no-hover" className={'invoice-item pointer border'}>
                        <div className="">
                            <input
                                checked={false}
                                onChange={() => {
                                    return null;
                                }}
                                className="checkbox-primary"
                                type="checkbox"
                            ></input>
                        </div>
                        <div>{translate('More than one reservation in conflict, please adjust them manualy!')}</div>
                        <div
                            onClick={() => {
                                useStore.getState().setNestedProperty(['state', 'checkoutInvoice', 'stayoverOverlap'], {
                                    overlapReservations: [],
                                    option: null,
                                    type: null,
                                });
                            }}
                            className={'button-white-only ml-4p'}
                        >
                            {translate('Cancel')}
                        </div>
                    </div>
                ) : (
                    <div
                        id="no-hover"
                        className={
                            optionCheck === 1 ? 'invoice-item-selected pointer border' : 'invoice-item pointer border'
                        }
                    >
                        <div className="">
                            <input
                                checked={optionCheck === 1 ? true : false}
                                onChange={() => {
                                    stayOverActions(overlapReservations, 1, 'applyCurrentDate');
                                }}
                                className="checkbox-primary"
                                type="checkbox"
                            ></input>
                        </div>
                        <div>{translate('Confirm the current date and move the next reservation.')}</div>
                        <div
                            onClick={async () => {
                                await applyCurrentCheckoutDate(reservation, location, reservationId, groupUuid);
                            }}
                            className={'button-white-only ml-4p pr-0'}
                        >
                            {translate('Apply')}
                        </div>
                    </div>
                )}
            </div>
        );
    } else return null;
};

const SelectedPosTerminal = (props: CheckoutOptionsProps) => {
    const { selectedPosTerminalId, PosTerminals } = props;

    if (PosTerminals.length === 0 || !selectedPosTerminalId) {
        return null;
    }

    const selectedPosTerminal = PosTerminals.find((p: PosTerminalModel) => p.id === selectedPosTerminalId);
    return (
        <div className="p-2 text-center bg-white mb-2">
            <h4 className="mb-0">{selectedPosTerminal && selectedPosTerminal.name}</h4>
        </div>
    );
};

const TypeOfPayment = (props: CheckoutOptionsProps) => {
    const { invoice, translate, fiscalGeneralSettings } = props;
    const { /* enableFiscalisation = false,*/ country = '' } = fiscalGeneralSettings
        ? fiscalGeneralSettings
        : { /*enableFiscalisation: false,*/ country: '' };

    const paymentTypes: PaymentType[] =
        country === 'BIH' || country === 'BIH-RS'
            ? [
                  {
                      name: 'Cash',
                      icon: (
                          <div className="color-dark">
                              <Cash width={28} height={28} />
                          </div>
                      ),
                      value: 'G',
                  },
                  {
                      name: 'Card',
                      icon: (
                          <div className="color-dark">
                              <Card width={28} height={28} />
                          </div>
                      ),
                      value: 'K',
                  },
                //   {
                //       name: 'Cheque',
                //       icon: (
                //           <div className="color-dark">
                //               <Cheque width={28} height={28} />
                //           </div>
                //       ),
                //       value: 'C',
                //   },
                  {
                      name: 'Virman',
                      icon: (
                          <div className="color-dark">
                              <Bill width={28} height={28} />
                          </div>
                      ),
                      value: 'V',
                  },
              ]
            : country === 'CRO'
            ? [
                  {
                      name: 'Cash',
                      icon: (
                          <div className="color-dark">
                              <Cash width={28} height={28} />
                          </div>
                      ),
                      value: 'G',
                  },
                  {
                      name: 'Card',
                      icon: (
                          <div className="color-dark">
                              <Card width={28} height={28} />
                          </div>
                      ),
                      value: 'K',
                  },
                //   {
                //       name: 'Cheque',
                //       icon: (
                //           <div className="color-dark">
                //               <Cheque width={28} height={28} />
                //           </div>
                //       ),
                //       value: 'C',
                //   },
                  {
                      name: 'Virman',
                      icon: (
                          <div className="color-dark">
                              <Bill width={28} height={28} />
                          </div>
                      ),
                      value: 'T',
                  },
                  // { name: 'Ostalo', icon: <Cash/>, value: 'O' },
              ]
            : [
                  {
                      name: 'G',
                      icon: (
                          <div className="color-dark">
                              <Cash width={28} height={28} />
                          </div>
                      ),
                      value: 'G',
                  },
                  {
                      name: 'K',
                      icon: (
                          <div className="color-dark">
                              <Card width={28} height={28} />
                          </div>
                      ),
                      value: 'K',
                  },
                //   {
                //       name: 'C',
                //       icon: (
                //           <div className="color-dark">
                //               <Cheque width={28} height={28} />
                //           </div>
                //       ),
                //       value: 'C',
                //   },
                  {
                      name: 'T',
                      icon: (
                          <div className="color-dark">
                              <Bill width={28} height={28} />
                          </div>
                      ),
                      value: 'T',
                  },
                  // { name: 'O', icon: <Cash/>, value: 'O' },
              ];

    const { pendingInvoice, typeOfPayment, invoiceType } = invoice;

    return (
        <div className="">
            <div className="mb-4p">
                <b>{translate('Type of payment')}</b>
            </div>
            <div className="button-group mb-8p">
                {paymentTypes.map((type, key) => {
                    return (
                        <button
                            disabled={!pendingInvoice || !invoice.id || invoiceType === InvoiceTypeEnum.proforma}
                            key={key}
                            onClick={() => {
                                const { value } = type;
                                setInvoiceProperties('typeOfPayment', value);
                            }}
                            className={
                                typeOfPayment === type.value
                                    ? 'button-light-selected mr-4p pt-0 pb-0 pl-0'
                                    : 'button-light-not-selected mr-4p pt-0 pb-0 pl-0'
                            }
                        >
                            {type.icon}
                            {translate(type.name)}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

const AccommodationInvoice = (props: CheckoutOptionsProps) => {
    const {
        invoice,
        accommodationInvoice,
        translate,
        genuineInvoices,
        reservationId,
        groupUuid,
        posTerminalInvoices,
        advanceInvoices,
        proformaInvoices,
        groupReservationsArray,
        // setInvoiceToSplit,
    } = props;

    const { terminalType } = invoice;

    // Invoicing settings za provjeru da li je boravišna već na predračunima
    const invoicingSettings = useStore((appState: any) => appState.invoicingSettings);
    const includeAccommodationTax = invoicingSettings?.includeAccommodationTax ?? 0;

    const accommodationProformasFromPosTerminal = posTerminalInvoices.filter((i) => {
        const { InvoiceItems } = i;
        const accommodationInvoiceItems = InvoiceItems.filter((it) => it.type === 'accommodation');
        if (accommodationInvoiceItems.length > 0 && i.reclamation === 0 && !i.connectedInvoiceProcessed) {
            return i;
        } else {
            return null;
        }
    });

    const accommodationGenuineFromPosTerminal = posTerminalInvoices.filter((pi) => {
        const { InvoiceItems } = pi;
        const accommodationInvoiceItems = InvoiceItems.filter((it) => it.type === 'accommodation');
        if (accommodationInvoiceItems.length > 0 && pi.reclamation === 0 && pi.connectedInvoiceProcessed) {
            return pi;
        } else {
            return null;
        }
    });

    const accommodationProformasFromReservation = proformaInvoices.filter((i) => {
        const { InvoiceItems } = i;
        const accommodationInvoiceItems = InvoiceItems.filter((it) => it.type === 'accommodation');
        if (accommodationInvoiceItems.length > 0 && i.reclamation === 0 && !i.connectedInvoiceProcessed) {
            return i;
        } else {
            return null;
        }
    });

    const accommodationProformas: InvoiceModelWithInvoiceItems[] = [];

    for (const invoice of accommodationProformasFromPosTerminal) {
        accommodationProformas.push(invoice);
    }
    for (const invoice of accommodationProformasFromReservation) {
        accommodationProformas.push(invoice);
    }

    const accomodationInvoiceIssued = genuineInvoices.filter((i) => {
        const { InvoiceItems } = i;
        const accommodationInvoiceItems = InvoiceItems.filter((it) => it.type === 'accommodation');
        if (accommodationInvoiceItems.length > 0) {
            return i;
        } else {
            return null;
        }
    });

    const advanceAccommodationFromPosTerminalInvoiceIssued = advanceInvoices.filter((a) => {
        const targetProforma = accommodationProformasFromPosTerminal.find(
            (p) =>
                a.connectedInvoices && a.connectedInvoices.length > 0 && Number(a.connectedInvoices[0]) === Number(p.id)
        );

        if (targetProforma) {
            return a;
        } else {
            return null;
        }
    });

    // Provjeri da li accommodationInvoice ima SAMO tax/insurance (bez accommodation)
    // To znači da je smještaj već pokriven predračunima, ali boravišna možda nije
    const hasOnlyTaxRemaining = React.useMemo(() => {
        if (!accommodationInvoice?.InvoiceItems || accommodationInvoice.InvoiceItems.length === 0) {
            return false;
        }
        const hasAccommodation = accommodationInvoice.InvoiceItems.some(
            (item: InvoiceItemsModel) => item.type === 'accommodation'
        );
        const hasTaxOrInsurance = accommodationInvoice.InvoiceItems.some(
            (item: InvoiceItemsModel) => item.type === 'tax' || item.type === 'insurance'
        );
        
        // Nema smještaj, ali ima pristojbu
        if (!hasAccommodation && hasTaxOrInsurance) {
            // Ako je includeAccommodationTax === 0 ili === 2, tax je VEĆ na predračunima
            // U tom slučaju, ne prikazuj obračun jer je tax već pokrivena
            if (includeAccommodationTax === 0 || includeAccommodationTax === 2) {
                return false;
            }
            // Ako je includeAccommodationTax === 1, tax je SAMO na fakturi
            // Prikaži obračun da se naplati boravišna
            return true;
        }
        return false;
    }, [accommodationInvoice, includeAccommodationTax]);

    if (
        !accommodationInvoice ||
        ((accommodationProformasFromPosTerminal.length > 0 ||
        accommodationGenuineFromPosTerminal.length > 0) && !hasOnlyTaxRemaining)
    ) {
        return (
            <div className="">
                <div className="display-flex justify-content-between">
                    <div className="mb-4p mt-12p font-14p">{translate('Accommodation invoices')}</div>
                    <div className="mb-4p">
                        <CheckoutDateMissmatch {...props} />
                    </div>
                </div>
                <GenuineAccommodationInvoices {...props} />
                <ConsumptionInvoiceList
                    keyName="accommodationProforma"
                    consumptionInvoices={accommodationProformas}
                    {...props}
                />
            </div>
        );
    }
    let showPrintInvoice = false;
    let showCancelButton = false;
    if (invoice.id) {
        if (terminalType === 'reservationConsumption') {
            showPrintInvoice = true;
        } else {
            showCancelButton = true;
        }
    } else {
        showPrintInvoice = true;
    }

    if (groupUuid && groupReservationsArray.length === 0 && accommodationProformasFromPosTerminal.length === 0) {
        return null;
    }

    return (
        <div>
            <div className="">
                <div className="display-flex justify-content-between">
                    <div className="mb-4p  mt-12p font-14p">{translate('Accommodation invoices')}</div>
                    <div className="mb-4p">
                        <CheckoutDateMissmatch {...props} />
                    </div>
                </div>
                <OverlapOptions {...props} />
                {(accomodationInvoiceIssued.length === 0 ||
                    (accomodationInvoiceIssued.length > 0 &&
                        accommodationInvoice &&
                        accommodationInvoice.totalValue)) &&
                (advanceAccommodationFromPosTerminalInvoiceIssued.length === 0 ||
                    (advanceAccommodationFromPosTerminalInvoiceIssued.length > 0 &&
                        accommodationInvoice &&
                        accommodationInvoice.totalValue)) &&
                accommodationInvoice &&
                accommodationInvoice.pendingInvoice &&
                accommodationInvoice.totalValue !== undefined &&
                accommodationInvoice.totalValue !== null ? (
                    groupUuid && groupReservationsArray.length === 0 ? null : (
                        <div
                            onClick={async () => {
                                if (showPrintInvoice) {
                                    await loadCheckoutInvoice({ reservationId, groupUuid });
                                    setAccommodationInvoice();
                                } else if (showCancelButton) {
                                    await loadCheckoutInvoice({ reservationId, groupUuid });
                                }
                            }}
                            className={!showCancelButton ? 'invoice-item pointer' : 'invoice-item-selected pointer'}
                        >
                            <div className="display-flex align-items-center">
                                <div className="">
                                    {showPrintInvoice ? (
                                        <React.Fragment>
                                            <input
                                                checked={!showPrintInvoice}
                                                onChange={async () => {
                                                    return null;
                                                }}
                                                className="checkbox-primary"
                                                type="checkbox"
                                            ></input>
                                        </React.Fragment>
                                    ) : null}
                                    {showCancelButton ? (
                                        <input
                                            checked={showCancelButton}
                                            onChange={async () => {
                                                return null;
                                            }}
                                            className="checkbox-primary"
                                            type="checkbox"
                                        ></input>
                                    ) : null}
                                </div>
                                <div className="ml-16p font-16p">{translate('Calculated room accommodation')}</div>
                            </div>
                            <div className="display-flex align-items-center">
                                <div className="mr-30p text-left">{dayjs().format('LL')}</div>

                                <div className="mr-16p">
                                    {numbro(
                                        Number(accommodationInvoice?.totalValue) *
                                            Number(accommodationInvoice?.currencyExchangeRate)
                                    ).format({
                                        mantissa: 2,
                                        trimMantissa: false,
                                        thousandSeparated: true,
                                    })}{' '}
                                    {accommodationInvoice?.currency}
                                </div>
                                <div>
                                    <AccommodationInvoiceOptions {...props} />
                                </div>
                            </div>
                        </div>
                    )
                ) : null}
                <GenuineAccommodationInvoices {...props} />
                <ConsumptionInvoiceList
                    keyName="accommodationProforma"
                    consumptionInvoices={accommodationProformas}
                    {...props}
                />
            </div>
        </div>
    );
};

const GenuineAccommodationInvoices = (props: CheckoutOptionsProps) => {
    const { genuineInvoices } = props;
    const [showMoreOptions, setShowMoreOptions] = React.useState<number | null>(null);

    const accomodationInvoiceIssued = genuineInvoices.filter((i) => {
        const { InvoiceItems } = i;
        const accommodationInvoiceItems = InvoiceItems.filter((it) => it.type === 'accommodation');
        if (accommodationInvoiceItems.length > 0) {
            return i;
        } else {
            return null;
        }
    });

    return (
        <div>
            {accomodationInvoiceIssued.map((gai: InvoiceModelWithInvoiceItems, index: number) => {
                return (
                    <div key={index} id="" className={'invoice-item disabled pointer mb-2p'}>
                        <div className="display-flex align-items-center">
                            <div className="mr-16p">
                                <input
                                    disabled={true}
                                    checked={false}
                                    onChange={() => {
                                        return null;
                                    }}
                                    className="checkbox-primary"
                                    type="checkbox"
                                ></input>
                            </div>
                            <div className="text-bold">
                                <Link
                                    key={index + 'link'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={'/invoiceView/' + gai.id + '?noActions'}
                                >
                                    #
                                    {gai.invoiceNumberFull?.split('/').map((tekst, index) => {
                                        if (index === 0) {
                                            return tekst;
                                        } else {
                                            return null;
                                        }
                                    })}
                                </Link>
                            </div>
                        </div>
                        <div className=""> {gai.timestamp ? dayjs(gai.timestamp).format('LL') : 'unknown'}</div>
                        <div className="display-flex align-items-center">
                            <div className="mr-16p">
                                {numbro(Number(gai.totalValue) * Number(gai.currencyExchangeRate)).format({
                                    mantissa: 2,
                                    trimMantissa: false,
                                    thousandSeparated: true,
                                })}{' '}
                                {gai.currency}
                            </div>
                            <div>
                                <PermissionCheck name="invoice_stornoInvoice">
                                <StornoInvoiceMenu
                                    setShowMoreOptions={setShowMoreOptions}
                                    showMoreOptions={showMoreOptions}
                                    invoice={gai}
                                    keyName={'accommodation'}
                                    index={index}
                                />
                                </PermissionCheck>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
interface StornoInvoiceMenuProps {
    setShowMoreOptions: Function;
    showMoreOptions: number | null;
    invoice: InvoiceModelWithInvoiceItems;
    keyName: string;
    index: number;
}

export const StornoInvoiceMenu = (props: StornoInvoiceMenuProps) => {
    const { setShowMoreOptions, showMoreOptions, invoice, keyName, index } = props;
    // const [localShowMoreOptions,  setLocalShowMoreOptions] =React.useState(true)
    const wrapperRef = React.useRef(null);

    useOutsideAlerter(wrapperRef, showMoreOptions, keyName);

    function useOutsideAlerter(ref: any, showMoreOptions: number | null, keyName: string) {
        React.useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target) && event.target.id !== keyName) {
                    if (showMoreOptions !== null) {
                        setShowMoreOptions(null);
                    }
                }
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref, showMoreOptions, keyName]);
    }

    return (
        <div style={{ position: 'relative' }}>
            <div
                className="pointer"
                onClick={() => {
                    if (showMoreOptions !== null) {
                        if (showMoreOptions === index) {
                            setShowMoreOptions(null);
                        } else {
                            setShowMoreOptions(index);
                        }
                    } else {
                        setShowMoreOptions(index);
                    }
                }}
            >
                <img id={keyName} src={chevronDown} alt="" />
                {showMoreOptions === index ? (
                    <div ref={wrapperRef} className="more-options-checkout-wrapper shadow-sm">
                        <div
                            className="more-options-checkout"
                            onClick={() => {
                                setInvoiceStornoPreview(invoice);
                            }}
                        >
                            <div className="mr-8p">
                                <Trash />
                            </div>
                            <div>{translate('Storno')}</div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

interface RemoveInvoiceMenuProps {
    setShowMoreOptions: Function;
    showMoreOptions: number | null;
    invoice: InvoiceModelWithInvoiceItems;
    keyName: string;
    index: number;
    reservationId: number | null;
    groupUuid: string | null;
}

export const RemoveInvoiceMenu = (props: RemoveInvoiceMenuProps) => {
    const { setShowMoreOptions, showMoreOptions, invoice, keyName, index, groupUuid, reservationId } = props;
    // const [localShowMoreOptions,  setLocalShowMoreOptions] =React.useState(true)
    const wrapperRef = React.useRef(null);

    useOutsideAlerter(wrapperRef, showMoreOptions, keyName);

    function useOutsideAlerter(ref: any, showMoreOptions: number | null, keyName: string) {
        React.useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target) && event.target.id !== keyName) {
                    if (showMoreOptions !== null) {
                        setShowMoreOptions(null);
                    }
                }
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref, showMoreOptions, keyName]);
    }

    return (
        <div style={{ position: 'relative' }}>
            <div
                className="pointer"
                onClick={(e) => {
                    e.stopPropagation();
                    if (showMoreOptions !== null) {
                        if (showMoreOptions === index) {
                            setShowMoreOptions(null);
                        } else {
                            setShowMoreOptions(index);
                        }
                    } else {
                        setShowMoreOptions(index);
                    }
                }}
            >
                <img id={keyName} src={chevronDown} alt="" />
                {showMoreOptions === index ? (
               
                    <div ref={wrapperRef} className="more-options-checkout-wrapper shadow-sm">
                        <div
                            className="more-options-checkout"
                            onClick={(e) => {
                                setModalContent(
                                    <div className="container-fluid">
                                        <div className="text-center">
                                            {translate('Please confirm.')}
                                            <hr />
                                        </div>

                                        <div className="text-center">
                                            <ConfirmButtons
                                                onConfirm={async () => {
                                                    const newInvoice = { ...invoice };
                                                    await addOrRemoveInvoice({
                                                        invoice: newInvoice,
                                                        add: false,
                                                        reservationId,
                                                        groupUuid,
                                                    });
                                                    closeModal();
                                                }}
                                                onCancel={() => {
                                                    closeModal();
                                                }}
                                            />
                                        </div>
                                    </div>,
                                    translate('Remove invoice'), // header
                                    false, // showCloseButton
                                    'modal-md'
                                );
                            }}
                        >
                            <div className=" mr-8p">
                                <Trash />
                            </div>
                            <div>{translate('Remove')}</div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

const CreateOrFindInvoice = (props: CheckoutOptionsProps) => {
    const { translate, history, reservationId, groupUuid, selectedPosTerminalId } = props;
    const [searchTerm, setSearchTerm] = React.useState('');
    const [invoices, setInvoices] = React.useState<InvoiceModelWithInvoiceItems[]>([]);

    const targetReservation = reservationId ? `?resId=${reservationId}` : `?resId=${groupUuid}`;

    const onInvoiceSearch = (e: any) => {
        clearTimeout(searchDebouncer);
        const searchString = e.target.value;
        setSearchTerm(searchString);
        searchDebouncer = setTimeout(async () => {
            const result = await searchInvoice(searchString);
            const filteredInvoices = result.filter((r) => r.terminalType === 'posTerminal').slice(0, 5);
            setInvoices(filteredInvoices);
        }, 500);
    };

    return (
        <React.Fragment>
            <div className="mb-4p">
                <b>{translate('Add invoice')}</b>
            </div>
            <div className="display-flex justify-content-between">
                <div className="input-group input-group-sm mr-8p">
                    <input
                        autoComplete="off"
                        placeholder={translate('Search by invoice number or invoice id')}
                        name="search"
                        value={searchTerm}
                        onChange={(e) => {
                            onInvoiceSearch(e);
                        }}
                        type="text"
                        className="form-control"
                    />
                </div>
                <div
                    onClick={() => {
                        reservationId || groupUuid
                            ? history.push('/posTerminal/' + selectedPosTerminalId + targetReservation)
                            : history.push('/posTerminal/' + selectedPosTerminalId);
                    }}
                    className="button-link"
                    style={{ paddingTop: '8px' }}
                >
                    {translate('Create invoice')}
                </div>
            </div>
            <div>
                {invoices.length > 0 ? (
                    <ul className="list-group list-group-flush mt-2">
                        {invoices.map((i: InvoiceModelWithInvoiceItems) => {
                            const { customerInfo, companyInfo } = i;
                            const customer = customerInfo
                                ? typeof customerInfo === 'string'
                                    ? JSON.parse(customerInfo)
                                    : customerInfo
                                : null;

                            const company = companyInfo
                                ? typeof companyInfo === 'string'
                                    ? JSON.parse(companyInfo)
                                    : companyInfo
                                : null;
                            return (
                                <li key={i.id} className="list-group-item p-1">
                                    <div className="d-flex align-items-center">
                                        <div className="pr-2 pl-2">
                                            <button
                                                onClick={() => {
                                                    const newInvoice = { ...i };
                                                    if (reservationId) {
                                                        newInvoice.reservationId = reservationId;
                                                    } else if (groupUuid) {
                                                        newInvoice.groupUuid = groupUuid;
                                                    }
                                                    addOrRemoveInvoice({ invoice: newInvoice, add: true ,reservationId, groupUuid});
                                                    setInvoices([]);
                                                    setSearchTerm('');
                                                }}
                                                className="button-primary"
                                            >
                                                {translate('Select')}
                                            </button>
                                        </div>
                                        <div className="pr-2 pl-2">
                                            <small>{i.invoiceNumberFull}</small>
                                        </div>
                                        {customer ? (
                                            <div className="pr-2 pl-2">
                                                <small>
                                                    {customer.firstName} {customer.lastName}
                                                </small>
                                            </div>
                                        ) : null}
                                        {company ? (
                                            <div className="pr-2 pl-2">
                                                <small>{company.name}</small>
                                            </div>
                                        ) : null}
                                        <div className="pr-2 pl-2">
                                            <small>
                                                {i.totalValue} {i.currency}
                                            </small>
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                ) : null}
            </div>
        </React.Fragment>
    );
};

interface SplitInvoiceProps {
    // posItems: PosItemModel[];
    invoiceToSplit: InvoiceModelWithInvoiceItems | null;
    setInvoiceToSplit: Function;
    reservationId: number | null;
    groupUuid: string | null;
    translate: Function;
    selectedPosTerminalId: number;
}

export const getGroupedInvoiceItemsByGroupAndType = (invoiceItems?: InvoiceItemsModel[]) => {
    const groupedInvoiceItemsByGroupAndType: Record<string, Record<string, InvoiceItemsModel[]>> = invoiceItems
        ? invoiceItems.reduce((groupedByGroup: any, invoiceItem: InvoiceItemsModel) => {
              const group = invoiceItem.group ? invoiceItem.group : 'null';
              const type = invoiceItem.type ? invoiceItem.type : 'null';

              if (group && type) {
                  if (!groupedByGroup[group]) {
                      groupedByGroup[group] = {};
                  }

                  if (!groupedByGroup[group][type]) {
                      groupedByGroup[group][type] = [];
                  }

                  groupedByGroup[group][type].push(invoiceItem);
              }
              return groupedByGroup;
          }, {})
        : {};
    return groupedInvoiceItemsByGroupAndType;
};

// NOTE: Import CSS file in your app: import './SplitInvoiceModal.css';



// Type configuration - using consistent colors
const TYPE_CONFIG: Record<string, { label: string; icon: string }> = {
    accommodation: { label: 'Accommodation', icon: '🏨' },
    posTerminal: { label: 'POS Items', icon: '🛒' },
    tax: { label: 'Accommodation tax', icon: '📋' },
    insurance: { label: 'Insurance', icon: '🛡️' },
};

export const SplitInvoiceModal = (props: SplitInvoiceProps) => {
    const { invoiceToSplit, setInvoiceToSplit, groupUuid, reservationId, translate, selectedPosTerminalId } = props;

    const [splitCount, setSplitCount] = React.useState<number>(2);
    const [posItems, setPosItems] = React.useState<PosItemModel[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [allocations, setAllocations] = React.useState<Record<string, number[]>>({});
    const [isInitialized, setIsInitialized] = React.useState<boolean>(false);
    const [editingInput, setEditingInput] = React.useState<string | null>(null);
    const [inputValue, setInputValue] = React.useState<string>('');
    
    // Ref za click outside detection
    const editingContextRef = React.useRef<{ itemKey: string; invoiceIdx: number; maxValue: number } | null>(null);
    
    // Toggle states
    const [equalSplitEnabled, setEqualSplitEnabled] = React.useState<boolean>(false);
    const [includeAdvances, setIncludeAdvances] = React.useState<boolean>(false);
    const [selectedAdvanceIndices, setSelectedAdvanceIndices] = React.useState<number[]>([]);
    
    // Collapsed sections state
    const [collapsedTypes, setCollapsedTypes] = React.useState<Record<string, boolean>>({});
    
    // Expanded row for slider
    const [expandedRow, setExpandedRow] = React.useState<string | null>(null);
    
    // POS item selection - allows changing which pos item is used for non-posTerminal types
    const [posItemIdOverrides, setPosItemIdOverrides] = React.useState<Record<string, number>>({});
    const [selectingItem, setSelectingItem] = React.useState<string | null>(null);

    const invoiceItems = invoiceToSplit?.InvoiceItems || [];
    const groupedInvoiceItems = getGroupedInvoiceItemsByGroupAndType(invoiceItems);
    const uniqueGroups = Object.keys(groupedInvoiceItems);

    // Stornirani avansni računi
    const stornoInvoices: InvoiceModelWithInvoiceItems[] = useStore(
        (state) => state.state.checkoutInvoice.stornoInvoices
    );

    // Invoicing settings za provjeru da li uključiti tax/insurance u split
    const invoicingSettings = useStore((appState: any) => appState.invoicingSettings);
    const includeAccommodationTax = invoicingSettings?.includeAccommodationTax ?? 0;

    const stornoAdvances = React.useMemo(() => {
        return stornoInvoices
            .filter((inv) => inv.invoiceType === 1)
            .map((inv) => ({
                ...inv,
                totalValue: Math.abs(Number(inv.totalValue) || 0),
            }));
    }, [stornoInvoices]);

    React.useEffect(() => {
        const loadPosItems = async () => {
            try {
                const items = await getPosItems();
                setPosItems(items);
            } catch (err) {
                console.error('Failed to load POS items:', err);
            }
        };
        loadPosItems();
    }, []);

    // Click outside handler - sprema vrijednost kad se klikne izvan inputa
    React.useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (!editingInput || !editingContextRef.current) return;
            
            const target = e.target as HTMLElement;
            // Ako je klik na input element s editing klasom, ignoriraj
            if (target.closest('.split-inline-input') || target.closest('.split-slider-input.editing')) {
                return;
            }
            
            // Spremi vrijednost - inline logika
            const { itemKey, invoiceIdx, maxValue } = editingContextRef.current;
            const parsed = parseFloat(inputValue);
            if (!isNaN(parsed)) {
                const clampedValue = Math.max(0, Math.min(parsed, maxValue));
                
                setAllocations((prev) => {
                    const updated = { ...prev };
                    const arr = [...(updated[itemKey] || Array(splitCount).fill(0))];

                    const usedByOthers = arr.reduce((sum, val, idx) => {
                        if (idx !== invoiceIdx && idx !== splitCount - 1) {
                            return sum + val;
                        }
                        return sum;
                    }, 0);
                    const availableForThis = maxValue - usedByOthers;

                    const finalValue = Math.round(Math.max(0, Math.min(clampedValue, availableForThis)) * 100) / 100;
                    arr[invoiceIdx] = finalValue;

                    const usedTotal = arr.reduce((sum, val, idx) => (idx !== splitCount - 1 ? sum + val : sum), 0);
                    const remainder = maxValue - usedTotal;
                    arr[splitCount - 1] = Math.round(Math.max(0, remainder) * 100) / 100;

                    updated[itemKey] = arr;
                    return updated;
                });
                
                // Isključi toggleove
                setEqualSplitEnabled(false);
                setIncludeAdvances(false);
            }
            setEditingInput(null);
            setInputValue('');
            editingContextRef.current = null;
        };

        // Dodaj listener s malim delay-om da se ne triggerira odmah
        const timeoutId = setTimeout(() => {
            document.addEventListener('mousedown', handleClickOutside);
        }, 100);

        return () => {
            clearTimeout(timeoutId);
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editingInput, inputValue, splitCount]);

    // Split items - UKLJUČUJE SVE (accommodation, posTerminal, tax, insurance)
    // OSIM ako je includeAccommodationTax === 1, tada tax/insurance idu samo na fakturu
    const splitItems = React.useMemo(() => {
        if (!invoiceToSplit || posItems.length === 0) return [];

        const items: {
            key: string;
            posItemId: number;
            type: string;
            group: string;
            itemName: string;
            maxQuantity: number;
            maxTotal: number;
            unitPrice: number;
            discountPercentage: number;
        }[] = [];

        const generalDiscount = invoiceToSplit.generalDiscountPercentage || 0;

        Object.keys(groupedInvoiceItems).forEach((group) => {
            const invoiceItemsByGroup = groupedInvoiceItems[group];

            Object.keys(invoiceItemsByGroup).forEach((type) => {
                // Skip tax/insurance ako je includeAccommodationTax === 1 (samo na fakturi, ne na predračunima)
                if (includeAccommodationTax === 1 && (type === 'tax' || type === 'insurance')) {
                    return;
                }

                const typeItems = invoiceItemsByGroup[type];

                if (type === 'posTerminal') {
                    typeItems.forEach((item: InvoiceItemsModel, idx: number) => {
                        if (item.posItemId) {
                            const quantity = Number(item.quantity) || 1;
                            const unitPrice = Number(item.bruttoUnitPrice) || 0;
                            const discountedUnitPrice = unitPrice * (1 - generalDiscount / 100);

                            items.push({
                                key: `${group}-${type}-${item.posItemId}-${idx}`,
                                posItemId: item.posItemId,
                                type,
                                group,
                                itemName: item.itemName || 'POS Item',
                                maxQuantity: quantity,
                                maxTotal: quantity * discountedUnitPrice,
                                unitPrice: discountedUnitPrice,
                                discountPercentage: item.discountPercentage || 0,
                            });
                        }
                    });
                } else {
                    typeItems.forEach((item: InvoiceItemsModel, idx: number) => {
                        // TOČNO kao stari kod - traži po tipu I cijeni, fallback samo po tipu
                        // Number() za usporedbu jer price može biti number a bruttoUnitPrice string
                        const posItem = posItems.find(
                            (p) => p.type === type && Number(p.price) === Number(item.bruttoUnitPrice)
                        ) || posItems.find((p) => p.type === type);

                        if (posItem && posItem.id) {
                            const quantity = Number(item.quantity) || 1;
                            const unitPrice = Number(item.bruttoUnitPrice) || 0;
                            // Pristojbe (tax, insurance) nemaju discount
                            const applyDiscount = type !== 'tax' && type !== 'insurance';
                            const discountPct = applyDiscount ? generalDiscount : 0;
                            const totalAmount = quantity * unitPrice * (1 - discountPct / 100);

                            items.push({
                                key: `${group}-${type}-${posItem.id}-${idx}`,
                                posItemId: posItem.id,
                                type,
                                group,
                                itemName: posItem.name || type,
                                maxQuantity: quantity,
                                maxTotal: totalAmount,
                                unitPrice: unitPrice * (1 - discountPct / 100),
                                discountPercentage: item.discountPercentage || 0,
                            });
                        }
                    });
                }
            });
        });

        return items;
    }, [invoiceToSplit, posItems, groupedInvoiceItems, includeAccommodationTax]);

    // Group items by type for collapsible sections
    const itemsByType = React.useMemo(() => {
        const grouped: Record<string, typeof splitItems> = {};
        splitItems.forEach((item) => {
            if (!grouped[item.type]) {
                grouped[item.type] = [];
            }
            grouped[item.type].push(item);
        });
        return grouped;
    }, [splitItems]);

    // Get type total
    const getTypeTotal = (type: string): number => {
        return (itemsByType[type] || []).reduce((sum, item) => sum + item.maxTotal, 0);
    };

    // Toggle collapsed state for a type
    const toggleCollapsed = (type: string) => {
        setCollapsedTypes((prev) => ({ ...prev, [type]: !prev[type] }));
    };

    // Group actions - move all items of a type to specific invoice
    const moveTypeToInvoice = (type: string, targetInvoiceIdx: number) => {
        setEqualSplitEnabled(false);
        setIncludeAdvances(false);
        
        setAllocations((prev) => {
            const updated = { ...prev };
            const typeItems = itemsByType[type] || [];
            
            typeItems.forEach((item) => {
                const arr = Array(splitCount).fill(0);
                const maxValue = item.type === 'posTerminal' ? item.maxQuantity : item.maxTotal;
                arr[targetInvoiceIdx] = maxValue;
                updated[item.key] = arr;
            });
            
            return updated;
        });
    };

    // Check if all items of a type are on specific invoice
    const isTypeOnInvoice = (type: string, invoiceIdx: number): boolean => {
        const typeItems = itemsByType[type] || [];
        if (typeItems.length === 0) return false;
        
        return typeItems.every((item) => {
            const arr = allocations[item.key] || [];
            const maxValue = item.type === 'posTerminal' ? item.maxQuantity : item.maxTotal;
            const valueOnInvoice = arr[invoiceIdx] || 0;
            return Math.abs(valueOnInvoice - maxValue) < 0.01;
        });
    };

    // Toggle type between invoice and final
    const toggleTypeInvoice = (type: string, invoiceIdx: number) => {
        if (isTypeOnInvoice(type, invoiceIdx)) {
            // Already on this invoice → move to Final
            moveTypeToInvoice(type, splitCount - 1);
        } else {
            // Not on this invoice → move here
            moveTypeToInvoice(type, invoiceIdx);
        }
    };


    // Round to 2 decimals
    const roundToDecimals = (value: number, decimals: number = 2): number => {
        const factor = Math.pow(10, decimals);
        return Math.round(value * factor) / factor;
    };

    // Reset sve na 0 (sve ide na Final invoice)
    const resetAllocations = React.useCallback(() => {
        const newAllocations: Record<string, number[]> = {};
        splitItems.forEach((item) => {
            const arr = Array(splitCount).fill(0);
            arr[splitCount - 1] = item.type === 'posTerminal' ? item.maxQuantity : item.maxTotal;
            newAllocations[item.key] = arr;
        });
        setAllocations(newAllocations);
    }, [splitItems, splitCount]);

    // Equal split
    const applyEqualSplit = React.useCallback(() => {
        const newAllocations: Record<string, number[]> = {};

        splitItems.forEach((item) => {
            if (item.type === 'posTerminal') {
                const baseQty = Math.floor(item.maxQuantity / splitCount);
                const remainder = item.maxQuantity % splitCount;
                newAllocations[item.key] = Array(splitCount)
                    .fill(0)
                    .map((_, idx) => baseQty + (idx < remainder ? 1 : 0));
            } else {
                const baseAmount = roundToDecimals(item.maxTotal / splitCount, 2);
                const amounts = Array(splitCount).fill(baseAmount);
                const totalAssigned = amounts.reduce((a, b) => a + b, 0);
                amounts[splitCount - 1] = roundToDecimals(
                    amounts[splitCount - 1] + (item.maxTotal - totalAssigned),
                    2
                );
                newAllocations[item.key] = amounts;
            }
        });

        setAllocations(newAllocations);
    }, [splitItems, splitCount]);

    // Split by advances - SEKVENCIJALNO: troši avans redom po itemima
    // Tax i insurance automatski idu na Final račun
    const applyAdvanceSplit = React.useCallback(() => {
        if (stornoAdvances.length === 0 || selectedAdvanceIndices.length === 0) return;

        const newAllocations: Record<string, number[]> = {};
        // Broj faktura = odabrani avansi + završni račun
        const currentSplitCount = selectedAdvanceIndices.length + 1;
        
        // Kreiraj array s preostalim iznosima SAMO za odabrane avanse
        const selectedAdvances = selectedAdvanceIndices.map((idx) => ({
            originalIndex: idx,
            value: stornoAdvances[idx].totalValue,
        }));
        const remainingAdvances = selectedAdvances.map((adv) => adv.value);

        // Prolazi kroz sve iteme
        splitItems.forEach((item) => {
            // Tax i Insurance → SVE na zadnji (Final) račun
            if (item.type === 'tax' || item.type === 'insurance') {
                const arr = Array(currentSplitCount).fill(0);
                arr[currentSplitCount - 1] = item.maxTotal;
                newAllocations[item.key] = arr;
                return;
            }

            // POS Terminal → SVE na zadnji račun
            if (item.type === 'posTerminal') {
                const arr = Array(currentSplitCount).fill(0);
                arr[currentSplitCount - 1] = item.maxQuantity;
                newAllocations[item.key] = arr;
                return;
            }

            // Accommodation → SEKVENCIJALNO troši odabrane avanse
            if (item.type === 'accommodation') {
                const amounts: number[] = Array(currentSplitCount).fill(0);
                let remainingItemAmount = item.maxTotal;

                // Prolazi kroz odabrane avanse redom i "troši" ih
                for (let i = 0; i < remainingAdvances.length; i++) {
                    if (remainingItemAmount <= 0) break;
                    if (remainingAdvances[i] <= 0) continue;

                    // Koliko možemo uzeti od ovog avansa?
                    const takeFromAdvance = Math.min(remainingAdvances[i], remainingItemAmount);
                    
                    amounts[i] = roundToDecimals(takeFromAdvance, 2);
                    remainingAdvances[i] -= takeFromAdvance;
                    remainingItemAmount -= takeFromAdvance;
                }

                // Ostatak ide na Final
                if (remainingItemAmount > 0) {
                    amounts[currentSplitCount - 1] = roundToDecimals(remainingItemAmount, 2);
                }

                newAllocations[item.key] = amounts;
                return;
            }

            // Ostalo → na zadnji račun
            const arr = Array(currentSplitCount).fill(0);
            arr[currentSplitCount - 1] = item.maxTotal;
            newAllocations[item.key] = arr;
        });

        setAllocations(newAllocations);
    }, [splitItems, stornoAdvances, selectedAdvanceIndices]);

    // Initialize allocations
    React.useEffect(() => {
        if (splitItems.length === 0) return;
        resetAllocations();
        setIsInitialized(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [splitItems.length, splitCount]);

    // Handle "Podijeli jednako" toggle
    const handleEqualSplitToggle = () => {
        if (equalSplitEnabled) {
            // OFF → reset na 0
            setEqualSplitEnabled(false);
            resetAllocations();
        } else {
            // ON → primijeni equal split
            setEqualSplitEnabled(true);
            setIncludeAdvances(false);
            applyEqualSplit();
        }
    };

    // Handle "Podijeli po avansima" toggle - odabire/deselektira SVE avanse
    const handleAdvancesToggle = () => {
        if (includeAdvances) {
            // OFF → reset
            setIncludeAdvances(false);
            setSelectedAdvanceIndices([]);
            setSplitCount(2);
            // Reset će se kroz useEffect
        } else {
            // ON → odaberi sve avanse
            setIncludeAdvances(true);
            setEqualSplitEnabled(false);
            const allIndices = stornoAdvances.map((_, idx) => idx);
            setSelectedAdvanceIndices(allIndices);
            const newSplitCount = stornoAdvances.length + 1;
            setSplitCount(newSplitCount);
            setTimeout(() => applyAdvanceSplit(), 50);
        }
    };

    // Handle pojedinačni avans toggle
    const handleAdvanceSelect = (advanceIdx: number) => {
        setSelectedAdvanceIndices((prev) => {
            let newSelected: number[];
            if (prev.includes(advanceIdx)) {
                // Deselektiraj
                newSelected = prev.filter((idx) => idx !== advanceIdx);
            } else {
                // Selektiraj i sortiraj
                newSelected = [...prev, advanceIdx].sort((a, b) => a - b);
            }
            
            // Ažuriraj splitCount
            const newSplitCount = newSelected.length > 0 ? newSelected.length + 1 : 2;
            setSplitCount(newSplitCount);
            
            // Ako nema odabranih, isključi includeAdvances
            if (newSelected.length === 0) {
                setIncludeAdvances(false);
            } else {
                setIncludeAdvances(true);
                setEqualSplitEnabled(false);
            }
            
            return newSelected;
        });
    };

    // Kad se uključi includeAdvances ili promijeni selectedAdvanceIndices
    React.useEffect(() => {
        if (includeAdvances && isInitialized && splitItems.length > 0 && selectedAdvanceIndices.length > 0) {
            applyAdvanceSplit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [includeAdvances, selectedAdvanceIndices.length, isInitialized]);

    // Kad se uključi equalSplit
    React.useEffect(() => {
        if (equalSplitEnabled && isInitialized && splitItems.length > 0) {
            applyEqualSplit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [equalSplitEnabled, splitCount, isInitialized]);

    const handleAllocationChange = (
        itemKey: string,
        invoiceIdx: number,
        newValue: number,
        maxValue: number,
        isQuantity: boolean
    ) => {
        // Ručna promjena → isključi OBA togglea
        setEqualSplitEnabled(false);
        setIncludeAdvances(false);

        setAllocations((prev) => {
            const updated = { ...prev };
            const arr = [...(updated[itemKey] || Array(splitCount).fill(0))];

            const usedByOthers = arr.reduce((sum, val, idx) => {
                if (idx !== invoiceIdx && idx !== splitCount - 1) {
                    return sum + val;
                }
                return sum;
            }, 0);
            const availableForThis = maxValue - usedByOthers;

            const clampedValue = Math.max(0, Math.min(newValue, availableForThis));
            const finalValue = isQuantity 
                ? Math.round(clampedValue) 
                : roundToDecimals(clampedValue, 2);

            arr[invoiceIdx] = finalValue;

            const usedTotal = arr.reduce((sum, val, idx) => (idx !== splitCount - 1 ? sum + val : sum), 0);
            const remainder = maxValue - usedTotal;
            arr[splitCount - 1] = roundToDecimals(Math.max(0, remainder), 2);

            updated[itemKey] = arr;
            return updated;
        });
    };

    const handleAutoSplitByRooms = async () => {
        if (!selectedPosTerminalId || !invoiceToSplit || uniqueGroups.length <= 1) return;

        setIsLoading(true);
        try {
            const consumptionsByGroup: PosTerminalConsumption[][] = uniqueGroups.map((group) => {
                return splitItems
                    .filter((item) => item.group === group)
                    .map((item) => {
                        // Use overridden posItemId if available
                        const effectivePosItemId = posItemIdOverrides[item.key] ?? item.posItemId;
                        return {
                            posItemId: effectivePosItemId,
                            quantity: item.maxQuantity,
                            newPrice: item.unitPrice, // FIX: uvijek unitPrice, backend množi s quantity
                            type: item.type,
                            total: item.maxTotal,
                            maxQuantity: item.maxQuantity,
                            maxTotal: item.maxTotal,
                            group: item.group,
                            discountPercentage: item.discountPercentage,
                        };
                    });
            });

            await splitInvoice(consumptionsByGroup, selectedPosTerminalId, invoiceToSplit);

            if (setInvoiceToSplit) {
                setInvoiceToSplit(null);
            }
            await loadCheckoutInvoice({ reservationId, groupUuid });
        } catch (err) {
            console.error('Auto split failed:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFinish = async () => {
        if (!selectedPosTerminalId || !invoiceToSplit) return;

        setIsLoading(true);
        try {
            const consumptions: PosTerminalConsumption[][] = Array(splitCount)
                .fill(null)
                .map((_, invoiceIdx) => {
                    const items: PosTerminalConsumption[] = [];

                    splitItems.forEach((item) => {
                        const value = allocations[item.key]?.[invoiceIdx] || 0;
                        if (value > 0) {
                            // Use overridden posItemId if available
                            const effectivePosItemId = posItemIdOverrides[item.key] ?? item.posItemId;
                            items.push({
                                posItemId: effectivePosItemId,
                                quantity: item.type === 'posTerminal' ? value : 1,
                                newPrice: item.type === 'posTerminal' ? item.unitPrice : value,
                                type: item.type,
                                total: item.type === 'posTerminal' ? value * item.unitPrice : value,
                                maxQuantity: item.maxQuantity,
                                maxTotal: item.maxTotal,
                                group: item.group,
                                discountPercentage: item.discountPercentage,
                            });
                        }
                    });

                    return items;
                });

            // Notes za advance invoices - samo za odabrane avanse
            const notes: (string | null)[] = Array(splitCount)
                .fill(null)
                .map((_, invoiceIdx) => {
                    if (includeAdvances && selectedAdvanceIndices.length > 0 && invoiceIdx < selectedAdvanceIndices.length) {
                        const advanceOriginalIdx = selectedAdvanceIndices[invoiceIdx];
                        const advance = stornoAdvances[advanceOriginalIdx];
                        if (advance) {
                            const advanceNumber = advance.invoiceNumberFull || `#${advance.id}`;
                            const paymentType = translate(advance.typeOfPayment || 'Unknown');
                            const advanceAmount = numbro(advance.totalValue).format({
                                mantissa: 2,
                                thousandSeparated: true,
                            });
                            return `${translate('Advance')}: ${advanceNumber} | ${translate('Payment')}: ${paymentType} | ${translate('Amount')}: ${advanceAmount}`;
                        }
                    }
                    return null;
                });

            await splitInvoice(consumptions, selectedPosTerminalId, invoiceToSplit, notes);

            if (setInvoiceToSplit) {
                setInvoiceToSplit(null);
            }
            await loadCheckoutInvoice({ reservationId, groupUuid });
        } catch (err) {
            console.error('Split invoice failed:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        if (setInvoiceToSplit) {
            setInvoiceToSplit(null);
        }
    };

    const getInvoiceTotal = (invoiceIdx: number): number => {
        return splitItems.reduce((sum, item) => {
            const value = allocations[item.key]?.[invoiceIdx] || 0;
            if (item.type === 'posTerminal') {
                return sum + value * item.unitPrice;
            }
            return sum + value;
        }, 0);
    };

    const isValid = React.useMemo(() => {
        if (!isInitialized) return false;

        return splitItems.every((item) => {
            const arr = allocations[item.key] || [];
            const total = arr.reduce((sum, val) => sum + val, 0);
            const max = item.type === 'posTerminal' ? item.maxQuantity : item.maxTotal;
            return Math.abs(total - max) < 0.01;
        });
    }, [allocations, splitItems, isInitialized]);

    const hasValidInvoices = Array(splitCount)
        .fill(0)
        .some((_, idx) => getInvoiceTotal(idx) > 0);

    if (!invoiceToSplit) return null;

    const getInvoiceLabel = (idx: number): string => {
        if (idx === splitCount - 1) {
            return translate('FINAL');
        }
        // Ako su odabrani avansi, prikaži iznos
        if (includeAdvances && selectedAdvanceIndices.length > 0 && idx < selectedAdvanceIndices.length) {
            const advanceOriginalIdx = selectedAdvanceIndices[idx];
            const advance = stornoAdvances[advanceOriginalIdx];
            if (advance) {
                return numbro(advance.totalValue).format({ mantissa: 0, thousandSeparated: true });
            }
        }
        return `${translate('INV')} ${idx + 1}`;
    };

    const getInvoiceLabelFull = (idx: number): string => {
        if (idx === splitCount - 1) {
            return translate('Final Invoice');
        }
        // Ako su odabrani avansi, prikaži detalje
        if (includeAdvances && selectedAdvanceIndices.length > 0 && idx < selectedAdvanceIndices.length) {
            const advanceOriginalIdx = selectedAdvanceIndices[idx];
            const advance = stornoAdvances[advanceOriginalIdx];
            if (advance) {
                return `${translate('Advance')} ${numbro(advance.totalValue).format({ mantissa: 2, thousandSeparated: true })}`;
            }
        }
        return `${translate('Invoice')} ${idx + 1}`;
    };

    const getTypeConfig = (type: string) => {
        return TYPE_CONFIG[type] || { label: type, icon: '📄' };
    };



    // Get effective posItemId (with override support)
    const getEffectivePosItemId = (itemKey: string, originalPosItemId: number): number => {
        return posItemIdOverrides[itemKey] ?? originalPosItemId;
    };

    // Get pos item name by id
    const getPosItemName = (itemKey: string, originalPosItemId: number, originalName: string): string => {
        const effectiveId = getEffectivePosItemId(itemKey, originalPosItemId);
        if (effectiveId !== originalPosItemId) {
            const posItem = posItems.find((p) => p.id === effectiveId);
            return posItem?.name || originalName;
        }
        return originalName;
    };

    // Get available pos items for a type (for Select dropdown)
    const getPosItemOptionsForType = (type: string): { value: number; label: string }[] => {
        return posItems
            .filter((p) => p.type === type)
            .map((p) => ({ value: p.id as number, label: p.name || type }));
    };

    // Handle pos item change
    const handlePosItemChange = (itemKey: string, newPosItemId: number) => {
        setPosItemIdOverrides((prev) => ({
            ...prev,
            [itemKey]: newPosItemId,
        }));
        setSelectingItem(null);
    };

    return (
        <div className="split-invoice-modal">
            {/* Header Row */}
            <div className="split-invoice-header">
                <h2 className="split-invoice-title">
                    {translate('Split Invoice')}
                </h2>

                <div className="split-count-control">
                    <span className="split-count-label">{translate('Split to')}:</span>
                    <button
                        type="button"
                        onClick={() => splitCount > 2 && setSplitCount(splitCount - 1)}
                        disabled={splitCount <= 2}
                        className="split-count-btn"
                    >−</button>
                    <span className="split-count-value">
                        {splitCount}
                    </span>
                    <button
                        type="button"
                        onClick={() => splitCount < 6 && setSplitCount(splitCount + 1)}
                        disabled={splitCount >= 6}
                        className="split-count-btn"
                    >+</button>
                </div>
            </div>

            {/* Quick Actions Row */}
            <div className="split-quick-actions">
                <button
                    type="button"
                    onClick={handleEqualSplitToggle}
                    className={`split-toggle-btn ${equalSplitEnabled ? 'active' : ''}`}
                >
                    <span className="toggle-indicator">{equalSplitEnabled ? '✓' : '○'}</span>
                    {translate('Split equally')}
                </button>

                {stornoAdvances.length > 0 && (
                    <button
                        type="button"
                        onClick={handleAdvancesToggle}
                        className={`split-toggle-btn ${includeAdvances ? 'active' : ''}`}
                    >
                        <span className="toggle-indicator">{includeAdvances ? '✓' : '○'}</span>
                        {translate('By advances')} ({stornoAdvances.length})
                    </button>
                )}

                {uniqueGroups.length > 1 && (
                    <button
                        type="button"
                        onClick={handleAutoSplitByRooms}
                        disabled={isLoading}
                        className="split-toggle-btn"
                    >
                        {translate('Auto by rooms')}
                    </button>
                )}
            </div>

            {/* Advances Selection Banner - prikazuje se kad ima avansa */}
            {stornoAdvances.length > 0 && (
                <div className="split-advances-banner">
                    <div className="split-advances-title">
                        {translate('Available advances')} ({stornoAdvances.length})
                    </div>
                    <div className="split-advances-list">
                        {stornoAdvances.map((adv, idx) => {
                            const isSelected = selectedAdvanceIndices.includes(idx);
                            return (
                                <div 
                                    key={adv.id} 
                                    className={`split-advance-item ${isSelected ? 'selected' : ''}`}
                                    onClick={() => handleAdvanceSelect(idx)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <input 
                                        type="checkbox" 
                                        checked={isSelected}
                                        onChange={() => {}}
                                        style={{ marginRight: '6px', cursor: 'pointer' }}
                                    />
                                    <span className="split-advance-value">
                                        {numbro(adv.totalValue).format({ mantissa: 2, thousandSeparated: true })}
                                    </span>
                                    <span className="split-advance-type">({translate(adv.typeOfPayment || 'V')})</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* Main Table */}
            <div className="split-table">
                {/* Table Header */}
                <div 
                    className="split-table-header"
                    style={{ gridTemplateColumns: `minmax(200px, 1fr) 90px ${Array(splitCount).fill('90px').join(' ')}` }}
                >
                    <div className="split-table-header-cell">
                        {translate('Item')}
                    </div>
                    <div className="split-table-header-cell text-right">
                        {translate('Total')}
                    </div>
                    {Array(splitCount).fill(0).map((_, idx) => (
                        <div 
                            key={idx} 
                            className={`split-table-header-cell text-center ${idx === splitCount - 1 ? 'final-col' : 'invoice-col'}`}
                        >
                            {getInvoiceLabel(idx)}
                        </div>
                    ))}
                </div>

                {/* Type Sections */}
                {Object.keys(itemsByType).map((type) => {
                    const typeItems = itemsByType[type];
                    const config = getTypeConfig(type);
                    const typeTotal = getTypeTotal(type);
                    const isCollapsed = collapsedTypes[type];
                    const itemCount = typeItems.length;

                    return (
                        <div key={type}>
                            {/* Type Header - Collapsible */}
                            <div 
                                onClick={() => toggleCollapsed(type)}
                                className="split-type-header"
                                style={{ gridTemplateColumns: `minmax(200px, 1fr) 90px ${Array(splitCount).fill('90px').join(' ')}` }}
                            >
                                <div className="split-type-info">
                                    <span className={`split-type-arrow ${isCollapsed ? 'collapsed' : ''}`}>
                                        ▼
                                    </span>
                                    <span className="split-type-icon">{config.icon}</span>
                                    <span className="split-type-label">
                                        {translate(config.label)}
                                    </span>
                                    <span className="split-type-count">({itemCount})</span>
                                </div>
                                <div className="split-type-total">
                                    {numbro(typeTotal).format({ mantissa: 2, thousandSeparated: true })}
                                </div>
                                {/* Quick actions per type - Toggle buttons */}
                                {Array(splitCount).fill(0).map((_, idx) => {
                                    const isLast = idx === splitCount - 1;
                                    const isActive = isTypeOnInvoice(type, idx);
                                    return (
                                        <div key={idx} style={{ display: 'flex', justifyContent: 'center' }}>
                                            {!isLast && (
                                                <button
                                                    type="button"
                                                    onClick={(e) => { e.stopPropagation(); toggleTypeInvoice(type, idx); }}
                                                    title={isActive ? `Remove from ${getInvoiceLabel(idx)}` : `${translate('ALL')} → ${getInvoiceLabel(idx)}`}
                                                    className={`split-type-toggle ${isActive ? 'active' : ''}`}
                                                >
                                                    {isActive ? '✓' : translate('ALL')}
                                                </button>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Type Items - Expandable */}
                            {!isCollapsed && typeItems.map((item) => {
                                const itemAllocs = allocations[item.key] || Array(splitCount).fill(0);
                                const maxValue = item.type === 'posTerminal' ? item.maxQuantity : item.maxTotal;
                                const isQuantityBased = item.type === 'posTerminal';
                                const isExpanded = expandedRow === item.key;
                                const posItemOptions = getPosItemOptionsForType(item.type);
                                const hasMultipleOptions = !isQuantityBased && posItemOptions.length > 1;
                                const isSelectOpen = selectingItem === item.key;
                                const effectivePosItemId = getEffectivePosItemId(item.key, item.posItemId);
                                const displayName = getPosItemName(item.key, item.posItemId, item.itemName);

                                return (
                                    <React.Fragment key={item.key}>
                                        {/* Compact Row */}
                                        <div 
                                            onClick={() => !isQuantityBased && !isSelectOpen && setExpandedRow(isExpanded ? null : item.key)}
                                            className={`split-item-row ${isExpanded ? 'expanded' : ''} ${!isQuantityBased ? 'clickable' : ''}`}
                                            style={{ gridTemplateColumns: `minmax(200px, 1fr) 90px ${Array(splitCount).fill('90px').join(' ')}` }}
                                        >
                                            {/* Item Name */}
                                            <div className="split-item-name">
                                                {!isQuantityBased && (
                                                    <span className={`split-item-expand-icon ${isExpanded ? 'expanded' : ''}`}>
                                                        ▶
                                                    </span>
                                                )}
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    {isSelectOpen ? (
                                                        <div onClick={(e) => e.stopPropagation()} style={{ width: '100%' }}>
                                                            <select
                                                                autoFocus
                                                                value={effectivePosItemId}
                                                                onChange={(e) => {
                                                                    const newId = Number(e.target.value);
                                                                    if (newId) {
                                                                        handlePosItemChange(item.key, newId);
                                                                    }
                                                                }}
                                                                onBlur={() => setSelectingItem(null)}
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '6px 8px',
                                                                    fontSize: '13px',
                                                                    border: '1px solid #1068ec',
                                                                    borderRadius: '4px',
                                                                    outline: 'none',
                                                                    backgroundColor: 'white',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                {posItemOptions.map((opt) => (
                                                                    <option key={opt.value} value={opt.value}>
                                                                        {opt.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    ) : (
                                                        <div className="split-item-title" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                {displayName}
                                                            </span>
                                                            {hasMultipleOptions && (
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectingItem(item.key);
                                                                        setExpandedRow(null);
                                                                    }}
                                                                    title={translate('Change item')}
                                                                    style={{
                                                                        background: 'none',
                                                                        border: '1px solid #d0d7de',
                                                                        borderRadius: '4px',
                                                                        padding: '2px 6px',
                                                                        cursor: 'pointer',
                                                                        fontSize: '11px',
                                                                        color: '#1068ec',
                                                                        flexShrink: 0,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '2px',
                                                                    }}
                                                                >
                                                                    <span style={{ fontSize: '10px' }}>↔</span>
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                                    {item.group !== 'null' && uniqueGroups.length > 1 && (
                                                        <div className="split-item-group">{item.group}</div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Item Total */}
                                            <div className="split-item-total">
                                                {numbro(item.maxTotal).format({ mantissa: 2, thousandSeparated: true })}
                                                {isQuantityBased && (
                                                    <div className="split-item-qty">
                                                        ×{item.maxQuantity}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Invoice Columns */}
                                            {itemAllocs.map((value, invoiceIdx) => {
                                                const isLast = invoiceIdx === splitCount - 1;
                                                const inputKey = `${item.key}-${invoiceIdx}`;
                                                const isEditing = editingInput === inputKey;
                                                const displayValue = isQuantityBased ? value : value;

                                                return (
                                                    <div key={invoiceIdx} style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                                                        {isQuantityBased ? (
                                                            // Quantity stepper for POS items
                                                            <div className="split-stepper">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => !isLast && handleAllocationChange(item.key, invoiceIdx, value - 1, maxValue, true)}
                                                                    disabled={isLast || value <= 0}
                                                                    className="split-stepper-btn"
                                                                >−</button>
                                                                <span className={`split-stepper-value ${isLast ? 'final' : ''}`}>
                                                                    {value}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => !isLast && handleAllocationChange(item.key, invoiceIdx, value + 1, maxValue, true)}
                                                                    disabled={isLast || itemAllocs[splitCount - 1] <= 0}
                                                                    className="split-stepper-btn"
                                                                >+</button>
                                                            </div>
                                                        ) : (
                                                            // Amount display for accommodation/tax - DIREKTNI UNOS
                                                            <div 
                                                                className={`split-item-value ${isLast ? 'final' : 'editable'}`}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (!isLast) {
                                                                        setEditingInput(inputKey);
                                                                        setInputValue(value === 0 ? '' : value.toFixed(2));
                                                                        editingContextRef.current = { itemKey: item.key, invoiceIdx, maxValue };
                                                                    }
                                                                }}
                                                                title={isLast ? '' : translate('Click to edit')}
                                                                style={!isLast ? {
                                                                    cursor: 'pointer',
                                                                    padding: '4px 8px',
                                                                    borderRadius: '4px',
                                                                    transition: 'background-color 0.15s',
                                                                    backgroundColor: isEditing ? 'transparent' : undefined,
                                                                } : undefined}
                                                                onMouseEnter={(e) => {
                                                                    if (!isLast && !isEditing) {
                                                                        (e.target as HTMLDivElement).style.backgroundColor = '#f0f4f8';
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (!isLast && !isEditing) {
                                                                        (e.target as HTMLDivElement).style.backgroundColor = 'transparent';
                                                                    }
                                                                }}
                                                            >
                                                                {isEditing && !isLast ? (
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        autoFocus
                                                                        value={inputValue}
                                                                        onChange={(e) => setInputValue(e.target.value)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                const parsed = parseFloat(inputValue);
                                                                                if (!isNaN(parsed)) {
                                                                                    const clampedValue = Math.max(0, Math.min(parsed, maxValue));
                                                                                    handleAllocationChange(item.key, invoiceIdx, clampedValue, maxValue, false);
                                                                                }
                                                                                setEditingInput(null);
                                                                                setInputValue('');
                                                                                editingContextRef.current = null;
                                                                            }
                                                                            if (e.key === 'Escape') { setEditingInput(null); setInputValue(''); editingContextRef.current = null; }
                                                                        }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        className="split-inline-input"
                                                                        style={{
                                                                            width: '70px',
                                                                            padding: '2px 4px',
                                                                            fontSize: '13px',
                                                                            textAlign: 'center',
                                                                            border: '1px solid #1068ec',
                                                                            borderRadius: '4px',
                                                                            outline: 'none',
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    numbro(displayValue).format({ mantissa: 2 })
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        {/* Expanded Slider Panel */}
                                        {isExpanded && !isQuantityBased && (
                                            <div className="split-slider-panel" onClick={(e) => e.stopPropagation()}>
                                                {itemAllocs.map((value, invoiceIdx) => {
                                                    const isLast = invoiceIdx === splitCount - 1;
                                                    const inputKey = `${item.key}-${invoiceIdx}`;
                                                    const isEditing = editingInput === inputKey;
                                                    const percentage = maxValue > 0 ? (value / maxValue) * 100 : 0;

                                                    return (
                                                        <div 
                                                            key={invoiceIdx}
                                                            className="split-slider-row"
                                                        >
                                                            {/* Invoice Label */}
                                                            <div className={`split-slider-label ${isLast ? 'final' : ''}`}>
                                                                {getInvoiceLabel(invoiceIdx)}
                                                            </div>

                                                            {/* Slider */}
                                                            <div className="split-slider-container">
                                                                <input
                                                                    type="range"
                                                                    min={0}
                                                                    max={maxValue}
                                                                    step={0.5}
                                                                    value={value}
                                                                    onChange={(e) =>
                                                                        !isLast &&
                                                                        handleAllocationChange(item.key, invoiceIdx, parseFloat(e.target.value), maxValue, false)
                                                                    }
                                                                    disabled={isLast}
                                                                    className="split-invoice-slider"
                                                                />
                                                                
                                                                {/* Percentage badge */}
                                                                <span className="split-slider-percentage">
                                                                    {percentage.toFixed(0)}%
                                                                </span>
                                                            </div>

                                                            {/* Editable Amount */}
                                                            {isEditing && !isLast ? (
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    autoFocus
                                                                    value={inputValue}
                                                                    onChange={(e) => setInputValue(e.target.value)}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            const parsed = parseFloat(inputValue);
                                                                            if (!isNaN(parsed)) {
                                                                                const clampedValue = Math.max(0, Math.min(parsed, maxValue));
                                                                                handleAllocationChange(item.key, invoiceIdx, clampedValue, maxValue, false);
                                                                            }
                                                                            setEditingInput(null);
                                                                            setInputValue('');
                                                                            editingContextRef.current = null;
                                                                        }
                                                                        if (e.key === 'Escape') { setEditingInput(null); setInputValue(''); editingContextRef.current = null; }
                                                                    }}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    className="split-slider-input editing"
                                                                />
                                                            ) : (
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        if (!isLast) {
                                                                            setEditingInput(inputKey);
                                                                            setInputValue(value === 0 ? '' : value.toFixed(2));
                                                                            editingContextRef.current = { itemKey: item.key, invoiceIdx, maxValue };
                                                                        }
                                                                    }}
                                                                    className={`split-slider-input ${isLast ? 'final' : ''}`}
                                                                    title={isLast ? '' : translate('Click to edit')}
                                                                    style={!isLast ? { cursor: 'pointer' } : undefined}
                                                                >
                                                                    {numbro(value).format({ mantissa: 2, thousandSeparated: true })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    );
                })}

                {/* Totals Row */}
                <div 
                    className="split-totals-row"
                    style={{ gridTemplateColumns: `minmax(200px, 1fr) 90px ${Array(splitCount).fill('90px').join(' ')}` }}
                >
                    <div className="split-totals-label">
                        {translate('TOTAL')}
                    </div>
                    <div className="split-totals-value">
                        {numbro(splitItems.reduce((sum, item) => sum + item.maxTotal, 0)).format({ mantissa: 2, thousandSeparated: true })}
                    </div>
                    {Array(splitCount).fill(0).map((_, idx) => {
                        const total = getInvoiceTotal(idx);
                        const isLast = idx === splitCount - 1;
                        return (
                            <div key={idx} className={`split-totals-invoice ${isLast ? 'final' : ''}`}>
                                {numbro(total).format({ mantissa: 2, thousandSeparated: true })}
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Summary Cards */}
            <div 
                className="split-summary-grid"
                style={{ gridTemplateColumns: `repeat(${Math.min(splitCount, 4)}, 1fr)` }}
            >
                {Array(splitCount).fill(0).map((_, invoiceIdx) => {
                    const total = getInvoiceTotal(invoiceIdx);
                    const isLast = invoiceIdx === splitCount - 1;
                    // Provjeri da li je ovo avans faktura i dohvati odgovarajući avans
                    const isAdvanceInvoice = includeAdvances && selectedAdvanceIndices.length > 0 && invoiceIdx < selectedAdvanceIndices.length;
                    const advanceOriginalIdx = isAdvanceInvoice ? selectedAdvanceIndices[invoiceIdx] : -1;
                    const expectedAmount = isAdvanceInvoice && advanceOriginalIdx >= 0 ? stornoAdvances[advanceOriginalIdx]?.totalValue : null;
                    const matchesAdvance = expectedAmount && Math.abs(total - expectedAmount) < 0.01;

                    return (
                        <div
                            key={invoiceIdx}
                            className={`split-summary-card ${isLast ? 'final' : ''}`}
                        >
                            <div className="split-summary-card-header">
                                <div className="split-summary-card-title">
                                    {getInvoiceLabelFull(invoiceIdx)}
                                </div>
                                {expectedAmount && (
                                    <div className={`split-summary-card-target ${matchesAdvance ? 'match' : 'mismatch'}`}>
                                        {matchesAdvance ? '✓' : '!'} {translate('Target')}: {numbro(expectedAmount).format({ mantissa: 2 })}
                                    </div>
                                )}
                            </div>
                            <div className="split-summary-card-body">
                                <div className={`split-summary-card-total ${total <= 0 ? 'empty' : ''}`}>
                                    {numbro(total).format({ mantissa: 2, thousandSeparated: true })}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Actions */}
            <div className="split-actions">
                <button
                    type="button"
                    onClick={handleCancel}
                    className="split-btn-cancel"
                >
                    {translate('Cancel')}
                </button>
                <LoadingButton
                    disabled={!isValid || !hasValidInvoices || isLoading}
                    onClick={handleFinish}
                    className="button-primary"
                >
                    {translate('Split invoices')}
                </LoadingButton>
            </div>
        </div>
    );
};

export const AccommodationInvoiceOptions = (props: CheckoutOptionsProps) => {
    const { invoice, /*roomInfoMap, */ reservation, location, reservationId, groupUuid } = props;
    const { pendingInvoice, id } = invoice;
    const [showMoreOptions, setShowMoreOptions] = React.useState<boolean>(false);
    const wrapperRef = React.useRef(null);

    useOutsideAlerter(wrapperRef, showMoreOptions);

    function useOutsideAlerter(ref: any, showMoreOptions: boolean) {
        React.useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target) && event.target.id !== 'accommodationOptions') {
                    if (showMoreOptions !== false) {
                        setShowMoreOptions(false);
                    }
                }
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref, showMoreOptions]);
    }
    // const roomInfo: RoomInfoEditModel | null = reservation && roomInfoMap ? roomInfoMap[reservation.roomInfoId] : null;
    if (!reservation) {
        return <div className="pl-16p pr-16p pt-16p pb-16p"></div>;
    }
    const { rememberedAccommodationPriceInfo } = reservation;

    const lastOffer: PriceOffer | null =
        rememberedAccommodationPriceInfo && rememberedAccommodationPriceInfo.length > 0
            ? rememberedAccommodationPriceInfo[rememberedAccommodationPriceInfo.length - 1]
            : null;

    const mismatchDateApplied: boolean =
        reservation && lastOffer && !dayjs(reservation.checkOutTimestamp).isSame(lastOffer.checkOutTimestamp, 'day')
            ? true
            : false;

    let showPreviousOffer: boolean = false;
    if (rememberedAccommodationPriceInfo && rememberedAccommodationPriceInfo.length > 1) {
        showPreviousOffer = true;
    }

    const showMissmatch =
        reservation.statusEnum === ReservationStatus.checkedIn && mismatchDateApplied && pendingInvoice && id
            ? true
            : false;

    const showPrevious = showPreviousOffer && pendingInvoice && id ? true : false;

    if (!showPrevious && !showMissmatch) {
        return <div className="pl-16p pr-16p pt-16p pb-16p"></div>;
    }

    return (
        <div style={{ position: 'relative' }}>
            <div
                className="pointer"
                onClick={(e) => {
                    e.stopPropagation();
                    setShowMoreOptions(!showMoreOptions);
                }}
            >
                <img id="accommodationOptions" src={chevronDown} alt="" />
                {(showMoreOptions && showMissmatch) || (showMoreOptions && showPrevious) ? (
                    <div ref={wrapperRef} className="more-options-checkout-wrapper shadow-sm">
                        {showMissmatch ? (
                            <div
                                className="more-options-checkout pl-8p pr-8p pt-8p pb-8p"
                                onClick={() => {
                                    const confirmationModalProps: ConfirmationModalProps = {
                                        title: translate('Previous checkout date'),
                                        callback: () => {
                                            restorePreviousCheckoutDate(
                                                reservation,
                                                location,
                                                reservationId,
                                                groupUuid
                                            );
                                        },
                                    };
                                    showConfirmationModal(confirmationModalProps);
                                }}
                            >
                                {/* <div className=" mr-8p">
                                 <Edit />
                             </div> */}
                                <div className="ml-8p pointer">{translate('Previous checkout date')}</div>
                            </div>
                        ) : null}
                        {showPrevious ? (
                            <div
                                className="more-options-checkout pl-8p pr-8p pt-8p pb-8p"
                                onClick={() => {
                                    setModalContent(
                                        <div className="container-fluid">
                                            <div className="text-center">
                                                {translate('Please confirm.')}
                                                <hr />
                                            </div>

                                            <div className="text-center">
                                                <ConfirmButtons
                                                    onConfirm={async () => {
                                                        await undoLastOffer({
                                                            reservationId,
                                                            groupUuid,
                                                        });

                                                        await loadCheckoutInvoice({ reservationId, groupUuid });
                                                        closeModal();
                                                    }}
                                                    onCancel={() => {
                                                        closeModal();
                                                    }}
                                                />
                                            </div>
                                        </div>,

                                        translate('Undo last offer'), //  header
                                        false, // showCloseButton
                                        'modal-md'
                                    );
                                }}
                            >
                                <div className="ml-8p pointer">{translate('Undo last offer')}</div>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export const SplitAndIssueInvoice = (props: CheckoutOptionsProps) => {
    const { invoice, setInvoiceToSplit, invoiceItems, advanceInvoices, invoicePreview } = props;

    const { connectedInvoices } = invoice;

    const invoiceWithInvoiceItems =
        invoice?.InvoiceItems && invoice.InvoiceItems.length > 0 ? invoice : { ...invoice, InvoiceItems: invoiceItems };

    const disableProformaSelectWhenAdvancereference = advanceInvoices.filter((a) => {
        if (
            a.connectedInvoices &&
            a.connectedInvoices.length > 0 &&
            connectedInvoices &&
            connectedInvoices.length > 0 &&
            connectedInvoices.includes(a.connectedInvoices[0])
        ) {
            return a;
        } else {
            return null;
        }
    });
    const disabledProformaInvoice: boolean =
        !invoice.id || disableProformaSelectWhenAdvancereference.length > 0 || invoice.advancePayments?.length > 0;
    const disableOnInvoicePreview: boolean =
        invoicePreview && Object.keys(invoicePreview.invoice).length > 0 ? true : false;

    return (
        <div
            onClick={() => {
                if (setInvoiceToSplit && !disabledProformaInvoice && !disableOnInvoicePreview) {
                    setInvoiceToSplit(invoiceWithInvoiceItems);
                }
            }}
            className={
                disabledProformaInvoice || disableOnInvoicePreview
                    ? ' button-info disabled mr-16p no-print '
                    : ' button-info mr-16p no-print'
            }
        >
            {translate('Split & issue...')}
        </div>
    );
};

const LoyaltyDiscount = (props: CheckoutOptionsProps) => {
    const { invoice, targetLoyaltyProgram } = props;

    const { pendingInvoice, invoiceType } = invoice;

    const loyaltyProgram = useStore((appState) => appState.state.checkoutInvoice.loyaltyProgram);
    const { loyaltyEnabled, isCandidate } = loyaltyProgram
        ? loyaltyProgram
        : { loyaltyEnabled: false, isCandidate: false };
    if (!pendingInvoice || invoiceType === InvoiceTypeEnum.advance || !invoice.id || !isCandidate) {
        return null;
    }

    return (
        <div className="truncated">
            <div
                className="mt-16p mr-40p pointer"
                onClick={async () => {
                    setLoyaltyProgram({ isCandidate: true, loyaltyEnabled: !loyaltyEnabled });
                    await recalculateReservationInvoice();
                }}
            >
                <div className="flex-center">
                    <label className="text-bold mr-8p mt-4p">
                        {translate('Apply') + ' ' + targetLoyaltyProgram?.name + ' ' + translate('package')}
                    </label>
                    <i className={`fa fa-2x ${loyaltyEnabled ? 'fa-check-square-o' : 'fa-square-o'}  pointer`}></i>
                </div>
            </div>
        </div>
    );
};


export default CheckoutOptions;

export { StornoInvoice, CurrencySelection, SelectLocale, CheckoutDateMissmatch, SelectedPosTerminal, TypeOfPayment };